import { __decorate, __metadata, __param } from 'tslib';
import { DomSanitizer, BrowserModule } from '@angular/platform-browser';
import { Injectable, EventEmitter, Output, Pipe, Inject, ɵɵdefineInjectable, ɵɵinject, Input, Component, Optional, SkipSelf, ContentChildren, QueryList, Injector, INJECTOR, SecurityContext, NgModule, ViewEncapsulation, NgZone, ViewChild, ElementRef, LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA, InjectionToken } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Location, NumberFormatStyle, DecimalPipe, getLocaleCurrencyName, CurrencyPipe, PercentPipe, DatePipe, registerLocaleData, getLocaleNumberSymbol, NumberSymbol, FormatWidth, getLocaleDateFormat, CommonModule } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { ListboxModule } from 'primeng/listbox';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Subject, interval, throwError, of, Observable, BehaviorSubject, combineLatest, forkJoin } from 'rxjs';
import { catchError, map, tap, flatMap } from 'rxjs/operators';
import { Router, ActivatedRoute, NavigationEnd, RouterModule } from '@angular/router';
import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import localeDataDe from '@angular/common/locales/de';
import { isDefined } from '@angular/compiler/src/util';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MenuModule } from 'primeng/menu';
import { MarkdownService, MarkdownModule } from 'ngx-markdown';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ScrollPanel } from 'primeng/scrollpanel';
import { TableModule } from 'primeng/table';
import { all } from 'deepmerge';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/common/http';
import * as ɵngcc4 from '@ngx-translate/core';
import * as ɵngcc5 from 'primeng/api';
import * as ɵngcc6 from 'primeng/menu';
import * as ɵngcc7 from 'primeng/toast';
import * as ɵngcc8 from 'primeng/tooltip';
import * as ɵngcc9 from 'primeng/dialog';
import * as ɵngcc10 from 'primeng/listbox';
import * as ɵngcc11 from '@angular/forms';
import * as ɵngcc12 from 'primeng/button';
import * as ɵngcc13 from 'primeng/dropdown';
import * as ɵngcc14 from 'ngx-markdown';
import * as ɵngcc15 from '@angular/platform-browser';
import * as ɵngcc16 from 'primeng/table';

function HeaderComponent_span_19_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 19);
    ɵngcc0.ɵɵelementStart(1, "span", 20);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_span_19_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.openTenantSelection(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("pTooltip", ctx_r4.tenantMultiLineTooltip)("escape", false);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r4.displayTenant, " |");
} }
function HeaderComponent_span_22_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r5.loginInfo.username || "SIGN_IN"));
} }
function HeaderComponent_span_23_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "SETTINGS"));
} }
function HeaderComponent_i_25_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 22);
    ɵngcc0.ɵɵlistener("click", function HeaderComponent_i_25_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ctx_r10.callHelp(undefined); });
    ɵngcc0.ɵɵelementEnd();
} }
const _c0 = function () { return { position: "fixed", width: "30em" }; };
const _c1 = function () { return { position: "fixed", width: "24em" }; };
function SidemenuComponent_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 8);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("pTooltip", !ctx_r1.version ? ɵngcc0.ɵɵpipeBind1(2, 4, "VERSION_NOT_FOUND") : ctx_r1.version);
    ɵngcc0.ɵɵproperty("escape", false);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate2(" ", ctx_r1.useInfraVersion === true ? ɵngcc0.ɵɵpipeBind1(4, 6, "INFRASTRUCTURE_VERSION_TITLE") : ɵngcc0.ɵɵpipeBind1(5, 8, "APP_VERSION_TITLE"), ":\u00A0", ctx_r1.versionShort, " ");
} }
function SidemenuComponent_div_8_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelement(2, "i", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate1("title", "Version:\u00A0", ctx_r2.version, "");
} }
function SidemenuComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵtemplate(1, SidemenuComponent_div_8_div_1_Template, 6, 10, "div", 7);
    ɵngcc0.ɵɵtemplate(2, SidemenuComponent_div_8_div_2_Template, 3, 1, "div", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngSwitch", ctx_r0.sidemenuService.isReduced);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", false);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", true);
} }
const _c2 = [[["ki-sidemenu-item"]]];
const _c3 = ["ki-sidemenu-item"];
function SidemenuItemComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 7);
} }
function SidemenuItemComponent_span_3_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMapInterpolate1("", ctx_r5.statusIcon.iconClass, " fa-stack-1x reduced-menu-status-icon");
} }
function SidemenuItemComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵelement(1, "i", 9);
    ɵngcc0.ɵɵtemplate(2, SidemenuItemComponent_span_3_i_2_Template, 1, 3, "i", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.sideMenuReduced ? "fa-stack" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r1.mainIconClasses);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.sideMenuReduced && ctx_r1.statusIcon);
} }
function SidemenuItemComponent_span_4_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 13);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMapInterpolate1("", ctx_r6.statusIcon.iconClass, " pull-right");
    ɵngcc0.ɵɵpropertyInterpolate("title", ctx_r6.statusIcon.iconTooltip);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r6.isSubItem ? "sub-item-status-icon" : "item-status-icon");
} }
function SidemenuItemComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, SidemenuItemComponent_span_4_i_2_Template, 1, 5, "i", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ctx_r2.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.statusIcon);
} }
function SidemenuItemComponent_i_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "i", 14);
    ɵngcc0.ɵɵlistener("click", function SidemenuItemComponent_i_6_Template_i_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.toggleSub(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r3.showSubmenu ? "fa fa-angle-down pull-right ki-sub-menu-toggle" : "fa fa-angle-right pull-right ki-sub-menu-toggle");
} }
function SidemenuItemComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r4.sideMenuReduced ? "ki-menu-sub-list-reduced" : "ki-menu-sub-list");
} }
const _c4 = ["*"];
const _c5 = function () { return { "minWidth": "400px" }; };
const _c6 = function () { return { "max-height": "250px", "overflow-y": "auto", "overflow-x": "hidden" }; };
function TenantComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "p-listbox", 4);
    ɵngcc0.ɵɵlistener("ngModelChange", function TenantComponent_div_4_div_1_Template_p_listbox_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.selectedTenantIdListx = $event; });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(5, _c5));
    ɵngcc0.ɵɵproperty("options", ctx_r2.tenantList)("ngModel", ctx_r2.selectedTenantIdListx)("listStyle", ɵngcc0.ɵɵpureFunction0(6, _c6));
} }
function TenantComponent_div_4_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "p-dropdown", 5);
    ɵngcc0.ɵɵlistener("ngModelChange", function TenantComponent_div_4_div_2_Template_p_dropdown_ngModelChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.selectedTenantIdx = $event; });
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(8, _c5));
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ɵngcc0.ɵɵpipeBind1(2, 6, "SELECT_TENANT"));
    ɵngcc0.ɵɵproperty("options", ctx_r3.tenantList)("ngModel", ctx_r3.selectedTenantIdx)("filter", true);
} }
function TenantComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, TenantComponent_div_4_div_1_Template, 2, 7, "div", 1);
    ɵngcc0.ɵɵtemplate(2, TenantComponent_div_4_div_2_Template, 3, 9, "div", 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.multiTenant);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.multiTenant);
} }
function TenantComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.error, " ");
} }
function LicenseViewerComponent_p_table_11_ng_template_2_th_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 14);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelement(2, "p-sortIcon", 15);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r8 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("pSortableColumn", col_r8.field);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", col_r8.header, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", col_r8.field);
} }
function LicenseViewerComponent_p_table_11_ng_template_2_th_3_input_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 18);
    ɵngcc0.ɵɵlistener("input", function LicenseViewerComponent_p_table_11_ng_template_2_th_3_input_1_Template_input_input_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const col_r9 = ɵngcc0.ɵɵnextContext().$implicit; ɵngcc0.ɵɵnextContext(2); const _r3 = ɵngcc0.ɵɵreference(1); return _r3.filter($event.target.value, col_r9.field, "contains"); });
    ɵngcc0.ɵɵelementEnd();
} }
function LicenseViewerComponent_p_table_11_ng_template_2_th_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 16);
    ɵngcc0.ɵɵtemplate(1, LicenseViewerComponent_p_table_11_ng_template_2_th_3_input_1_Template, 1, 0, "input", 17);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r9 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("ngSwitch", col_r9.type);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngSwitchCase", "string");
} }
function LicenseViewerComponent_p_table_11_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵtemplate(1, LicenseViewerComponent_p_table_11_ng_template_2_th_1_Template, 3, 3, "th", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "tr");
    ɵngcc0.ɵɵtemplate(3, LicenseViewerComponent_p_table_11_ng_template_2_th_3_Template, 2, 2, "th", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.columns);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.columns);
} }
function LicenseViewerComponent_p_table_11_ng_template_3_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 20);
    ɵngcc0.ɵɵlistener("click", function LicenseViewerComponent_p_table_11_ng_template_3_button_2_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r17); const package_r14 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.onSelectLicense($event, package_r14.license); });
    ɵngcc0.ɵɵelementEnd();
} }
function LicenseViewerComponent_p_table_11_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵelementStart(1, "td");
    ɵngcc0.ɵɵtemplate(2, LicenseViewerComponent_p_table_11_ng_template_3_button_2_Template, 1, 0, "button", 19);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "td");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "td");
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "td");
    ɵngcc0.ɵɵtext(9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const package_r14 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", (package_r14 == null ? null : package_r14.license) !== undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", package_r14 == null ? null : package_r14.name, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(package_r14 == null ? null : package_r14.version);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", package_r14 == null ? null : package_r14.license == null ? null : package_r14.license.name, " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(package_r14 == null ? null : package_r14.license == null ? null : package_r14.license.type);
} }
function LicenseViewerComponent_p_table_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p-table", 8, 9);
    ɵngcc0.ɵɵtemplate(2, LicenseViewerComponent_p_table_11_ng_template_2_Template, 4, 2, "ng-template", 10);
    ɵngcc0.ɵɵtemplate(3, LicenseViewerComponent_p_table_11_ng_template_3_Template, 10, 5, "ng-template", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const thirdPartyLicenses_r2 = ctx.ngIf;
    ɵngcc0.ɵɵproperty("value", thirdPartyLicenses_r2)("lazy", false)("autoLayout", true)("sortField", "name")("sortOrder", 1);
} }
function LicenseViewerComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.selectedLicense == null ? null : ctx_r1.selectedLicense.name, " ");
} }
const _c7 = function () { return { width: "990px", maxHeight: "500px", minHeight: "200px", "overflow-y": "auto", "overflow-x": "hidden" }; };
let SidemenuService = class SidemenuService {
    constructor() {
        this.isReduced = false;
        this.reducedChangeSubject = new Subject();
    }
    getReducedObservable() {
        return this.reducedObservable;
    }
    setSideMenuReduced(reduced) {
        this.isReduced = reduced;
        this.reducedChangeSubject.next(reduced);
    }
};
SidemenuService.ɵfac = function SidemenuService_Factory(t) { return new (t || SidemenuService)(); };
SidemenuService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: SidemenuService, factory: SidemenuService.ɵfac });
SidemenuService = __decorate([ __metadata("design:paramtypes", [])
], SidemenuService);

let ParameterService = class ParameterService {
    constructor(router, location) {
        this.router = router;
        this.location = location;
        this.parameters = {};
        this.subject = new Subject();
        let urlTree = router.parseUrl(location.path(true));
        this.fragment = urlTree.fragment;
        if (Object.keys(urlTree.queryParams).length === 0 && urlTree.fragment) {
            urlTree = router.parseUrl(urlTree.fragment);
            this.parameters = urlTree.queryParams;
        }
        else {
            this.parameters = urlTree.queryParams;
        }
    }
    ngOnDestroy() {
        this.subject.complete();
    }
    subscribe(next, error, complete) {
        return this.subject.subscribe(next, error, complete);
    }
    /**
     * Get the value for a given key.
     * @param key the key
     * @returns the value of the given key
     */
    getValue(key) {
        return this.parameters[key] ? this.parameters[key] : '';
    }
    /**
     * Set the value for a given key.
     * @param key the given key
     * @param value the value
     */
    setValue(key, value) {
        const old = this.parameters[key];
        this.parameters[key] = value;
        this.toLocation();
        this.subject.next({ key: key, old: old, new: value });
    }
    /**
     * Search the URL for parameters.
     * @returns the string with the parameters
     */
    searchParams(path) {
        if (!path) {
            path = this.location.path();
        }
        const urlTree = this.getUrlTree(path);
        urlTree.fragment = undefined;
        return this.router.serializeUrl(urlTree).split('?', 2)[1];
    }
    /**
     * Parse url tree of given path and add all parameter.
     */
    getUrlTree(path) {
        const urlTree = this.router.parseUrl(path);
        Object.keys(this.parameters).forEach((key) => {
            urlTree.queryParams[key] = this.parameters[key];
        });
        return urlTree;
    }
    /**
     * Update location using parameter(s) and / or fragment if needed.
     */
    toLocation() {
        const urlTree = this.router.parseUrl(this.location.path());
        Object.keys(this.parameters).forEach((key) => {
            urlTree.queryParams[key] = this.parameters[key];
        });
        if (this.fragment) {
            urlTree.fragment = this.fragment;
        }
        this.location.replaceState(this.router.serializeUrl(urlTree));
    }
    /**
     * Compose a URL.
     * @param app a given application
     * @returns the URL to navigate to
     */
    composeUrl(app) {
        if (!app || !app.url || app.url.length === 0) {
            return '';
        }
        if (Object.keys(this.parameters).length === 0) {
            return app.url;
        }
        const options = app.options;
        if (options && options.noQueryParams && options.noQueryParams === true) {
            return app.url;
        }
        let protocol = '';
        if (app.url.indexOf('//') > 0) {
            const urlParts = app.url.split('//');
            protocol = urlParts[0];
            app.url = urlParts[1];
        }
        const urlTree = this.getUrlTree(app.url);
        let url = this.router.serializeUrl(urlTree);
        if (options && options.paramPrevAnchor && options.paramPrevAnchor) {
            return url;
        }
        let parts = url.split('?', 2);
        const urlPart = parts[0];
        const paramsAndFragment = parts[1];
        let params = '';
        let fragment = '';
        if (paramsAndFragment) {
            parts = paramsAndFragment.split('#', 2);
            params = parts[0];
            fragment = parts[1];
            if (!params) {
                params = '';
            }
            else {
                params = '/?' + params;
            }
            if (!fragment) {
                fragment = '/#';
            }
            else {
                fragment = '/#' + (fragment.startsWith('/') ? '' : '/') + fragment;
            }
        }
        url = urlPart + fragment + params;
        url = this.location.normalize(url);
        if (url.startsWith('/')) {
            url = url.substring(1);
        }
        if (protocol) {
            // if a specific protocol was set, re-add it
            url = protocol + '//' + url;
        }
        return url;
    }
};
ParameterService.ɵfac = function ParameterService_Factory(t) { return new (t || ParameterService)(ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(ɵngcc2.Location)); };
ParameterService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ParameterService, factory: ParameterService.ɵfac });
ParameterService.ctorParameters = () => [
    { type: Router },
    { type: Location }
];
ParameterService = __decorate([ __metadata("design:paramtypes", [Router, Location])
], ParameterService);

class AuthInfo {
}
let AuthService = class AuthService {
    constructor(http, parameterService) {
        this.http = http;
        this.parameterService = parameterService;
        this.baseUrl = this.createLogoutRedirectBaseUri();
        this.portalAuthBasePath = '/api/auth/energy-portal';
        this.authBasePath = this.portalAuthBasePath;
        this.logoutRedirectUrl = '/ui/energy/web/frame';
        this.intervalTime = 30000;
        this.refreshTokenRetries = 0;
        /**
         * This function iterates over all applications and call the logout url if exists.
         * If the iteration is finished the KeyCloak logout will be called to remove the current user session.
         *
         * @param applicationList the application list
         * @param index current application index
         */
        this.logoutAll = (applicationList, index) => {
            let i = index ? index : 0;
            const that = this;
            if (applicationList !== undefined) {
                setTimeout(function () {
                    const app = applicationList[i];
                    // no more application to iterate
                    if (app === undefined) {
                        this.authinfo = undefined;
                        // parameterService.setValue('tenant', null);
                        that.getLogoutUrl().subscribe((data) => {
                            window.location.href =
                                data +
                                    '?redirect_uri=' +
                                    encodeURIComponent(that.baseUrl + '/ui/energy/web/frame');
                        });
                        return;
                    }
                    // call logout flow only of logout url is set
                    if (!app.logoutUrl) {
                        console.log('The logout url is missing for application: ' +
                            app.name +
                            '! Logout process canceled.');
                    }
                    else {
                        that._sendRequest(app.logoutUrl);
                    }
                    if (i === applicationList.length) {
                        this.removeRefreshTokenHTMLElement();
                    }
                    // get next application
                    i++;
                    if (i <= applicationList.length) {
                        return that.logoutAll(applicationList, i);
                    }
                }, 500);
            }
        };
        this.loginState = new Subject();
    }
    /**
     * Set the URL for the authorization flow (kept so that apps keep working with the old call).
     * @param authUrl the authorization url
     */
    authUrl(authUrl) {
        this.setApplicationBasePath(authUrl);
    }
    /**
     * Set the logout redirect URL.
     * @param logoutRedirectUiUrl the logout redirect URL
     */
    setLogoutRedirectUiUrl(logoutRedirectUiUrl) {
        this.logoutRedirectUrl = logoutRedirectUiUrl;
    }
    /**
     * Set the application base url for the specific application authorization redirect flow.
     * @param basePath the application base path to the auth API
     */
    setApplicationBasePath(basePath) {
        this.authBasePath = basePath;
    }
    login(reqUrl, hidden) {
        // set the selected application
        let requiredTenant = 'false';
        const currentPath = window.location.href;
        if (this.authInfo) {
            if (this.authInfo.username) {
                if (!this.selectedApp) {
                    this.selectedAppUpdated = new EventEmitter();
                    this.selectedAppUpdated.emit('selectedApp:updated');
                    if (!this.selectedApp) {
                        console.log('Application is not selected.');
                    }
                }
                else {
                    requiredTenant = this.selectedApp.requireTenant;
                }
                if (this.parameterService) {
                    // set query parameter if missing
                    this.parameterService.toLocation();
                }
            }
            this.loginState.next({ loggedin: true });
        }
        else {
            this.loginState.next({ loggedin: false });
        }
        /* Change the baseUrl if a NotAuthorizedException is occurred through the frame back-end (e.q. applications cannot received).
        This case occurs when the application is called (without frame login so that no frame cookie is set).
        To get the authorized application list, the redirect flow for the frame must be triggered.
        */
        let lAuthBasePath = this.authBasePath;
        if (reqUrl && reqUrl.indexOf('/rest/energy/portal') !== -1) {
            lAuthBasePath = this.portalAuthBasePath;
        }
        let loginUrl = '';
        if (requiredTenant) {
            loginUrl =
                lAuthBasePath +
                    '/login?state=' +
                    encodeURIComponent(currentPath) +
                    '&tenant=' +
                    this.parameterService.getValue('tenant') +
                    '&requiredTenant=' +
                    encodeURIComponent(requiredTenant);
        }
        else {
            loginUrl =
                lAuthBasePath +
                    '/login?state=' +
                    encodeURIComponent(currentPath) +
                    '&requiredTenant=' +
                    encodeURIComponent('false');
        }
        if (hidden) {
            // iframe
            let refreshTokenHTMLElement = document.getElementById('refresh-frame');
            if (refreshTokenHTMLElement) {
                document.body.removeChild(refreshTokenHTMLElement);
            }
            if (this.refreshTokenRetries < 5) {
                refreshTokenHTMLElement = document.createElement('iframe');
                refreshTokenHTMLElement.id = 'refresh-frame';
                refreshTokenHTMLElement.src = loginUrl;
                refreshTokenHTMLElement.style = 'visibility: hidden';
                document.body.appendChild(refreshTokenHTMLElement);
                this.enableCheckTokenHeartBeat(5000);
                this.refreshTokenRetries++;
                return;
            }
        }
        else {
            window.location.href = loginUrl;
        }
    }
    disableCheckTokenHeartBeat() {
        if (this.checkTokenSubscription) {
            this.checkTokenSubscription.unsubscribe();
            this.checkTokenSubscription = undefined;
        }
        this.checkTokenSource = undefined;
    }
    enableCheckTokenHeartBeat(intervalTime) {
        if (intervalTime && intervalTime >= 0) {
            this.intervalTime = intervalTime;
        }
        this.disableCheckTokenHeartBeat();
        this.checkTokenSource = interval(this.intervalTime);
        this.checkTokenSubscription = this.checkTokenSource.subscribe(() => {
            this.checkToken()
                .pipe(catchError((errorResponse) => {
                if (errorResponse.status === 401) {
                    console.debug('token still invalid 401: ', errorResponse);
                }
                console.debug('token still invalid != 401: ', errorResponse);
                return throwError(errorResponse);
            }))
                .subscribe((result) => {
                console.debug('token still valid: ', result);
                if (this.intervalTime === 5000) {
                    this.intervalTime = 30000;
                    this.refreshTokenRetries = 0;
                    const refreshTokenHTMLElement = document.getElementById('refresh-frame');
                    if (refreshTokenHTMLElement) {
                        document.body.removeChild(refreshTokenHTMLElement);
                    }
                    this.enableCheckTokenHeartBeat(30000);
                }
            });
        });
    }
    /**
     * Get Observable for AuthInfo.
     */
    getAuthInfo() {
        // if there is valid authInfo in the service 'cache', return as observable
        if (this.authInfo) {
            return of(this.authInfo);
        }
        // else, create a new Observable and pipe the result to the service 'cache'
        return new Observable((observer) => {
            this.http
                .get(this.authBasePath + '/authinfo')
                .pipe(map((res) => this.setAuthInfo(res)))
                .subscribe((res) => {
                observer.next(res);
                observer.complete();
            }, (err) => {
                return observer.error(err);
            });
        });
    }
    /**
     * Set authentication information 'cache'.
     * @param authInfo the authentication information
     */
    setAuthInfo(authInfo) {
        this.authInfo = authInfo;
        return authInfo;
    }
    /**
     * Get Observable for user roles string[].
     */
    getUserRoles() {
        return this.http
            .get(this.authBasePath + '/user/roles')
            .pipe(map((roles) => roles));
    }
    /**
     * Set the selected application for OAuth2 flow.
     * @param application the current application
     */
    setSelectedApp(application) {
        if (application !== undefined) {
            if (!this.selectedApp) {
                this.selectedApp = application;
            }
            else {
                if (this.selectedApp.name !== application.name) {
                    this.selectedApp = application;
                }
            }
        }
    }
    getLogoutUrl() {
        return this.http.get(this.authBasePath + '/logoutUrl', {
            responseType: 'text'
        });
    }
    getUserProfilePath() {
        return new Observable((observer) => {
            this.http
                .get(this.authBasePath + '/account', {
                withCredentials: true,
                responseType: 'text',
                headers: { Accept: 'text/plain, */*' }
            })
                .subscribe((data) => {
                let profilePath = data;
                if (profilePath.indexOf('referrer_uri=') < 1) {
                    // the application backend should set a referrer_uri, but if it's missing, add current path
                    // const referrer_URI = encodeURIComponent(window.location.origin + window.location.pathname);
                    const referrer_URI = window.location.href;
                    if (profilePath.indexOf('?') > 0) {
                        profilePath += '&';
                    }
                    else {
                        profilePath += '?';
                    }
                    profilePath += 'referrer_uri=' + referrer_URI;
                }
                if (profilePath.indexOf('theme') < 1) {
                    // check if a theme is stored in parameterService
                    const theme = this.parameterService.getValue('theme');
                    if (theme) {
                        profilePath += '&theme=' + theme;
                    }
                }
                observer.next(profilePath);
                observer.complete();
            }, (err) => observer.error(err));
        });
    }
    /**
     * Trigger the KiGatekeeper/KeyCloak logout and reset all frame authorization infos.
     */
    logout() {
        if (this.checkTokenSubscription) {
            this.checkTokenSubscription.unsubscribe();
            this.checkTokenSubscription = undefined;
        }
        this.checkTokenSource = undefined;
        this.http
            .request('POST', this.baseUrl + this.authBasePath + '/logout', {
            headers: { Accept: 'application/json, text/plain, */*' }
        })
            .subscribe((data) => {
            this.authInfo = undefined;
            this.parameterService.setValue('tenant', null);
            this.http
                .get(this.baseUrl + '/logoutUrl', {
                withCredentials: true,
                responseType: 'text',
                headers: { Accept: 'text/plain, */*' }
            })
                .subscribe((response) => {
                window.location.href =
                    response +
                        '?redirect_uri=' +
                        encodeURIComponent(this.baseUrl + this.logoutRedirectUrl);
            });
        });
    }
    /**
     * Create a temporary div to define an iFrame.
     *
     * @param id the iFrame id
     * @returns temporary div element
     */
    createTempDiv(id) {
        const rDiv = document.createElement('div');
        rDiv.id = 'tempDiv';
        rDiv.style.cursor = 'progress';
        const style = 'border:0;width:0;height:0;';
        rDiv.innerHTML =
            '<iframe name="' +
                id +
                '" id="' +
                id +
                '"style="' +
                style +
                '"></iframe>';
        const form = document.createElement('form');
        form.setAttribute('id', id + 'TempForm');
        form.setAttribute('action', 'blank.html');
        form.setAttribute('target', id);
        form.target = id;
        form.setAttribute('method', 'post');
        rDiv.appendChild(form);
        document.body.appendChild(rDiv);
        return rDiv;
    }
    /**
     * Submit logout request.
     *
     * @param url the application logout url
     */
    _sendRequest(url) {
        if (!this.tempDiv) {
            this.tempDiv = this.createTempDiv('tempFrame');
        }
        const form = this.tempDiv.childNodes[1];
        form.action = url;
        form.submit();
    }
    /**
     * Creates the (absolut) base URI, consisting out of protocol, host, domain and (optional) the port.
     * The port is only part of the uri if it does not a default port (80 or 443).
     * ### Examples:
     * - https://myhost.mydomain.de
     * - http://myhost.mydomain.de:8081
     */
    createLogoutRedirectBaseUri() {
        let baseUrl = window.location.protocol + '//' + window.location.hostname;
        if (window.location.port !== undefined && window.location.port !== '') {
            // SEP-274 - Wrong redirect URL on logout if a standard port (80 or 443) is used
            baseUrl += ':' + window.location.port;
        }
        return baseUrl;
    }
    checkToken() {
        return this.http.get(this.authBasePath + '/refreshaccesstoken');
    }
};
AuthService.ɵfac = function AuthService_Factory(t) { return new (t || AuthService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(ParameterService)); };
AuthService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: AuthService, factory: AuthService.ɵfac });
AuthService.ctorParameters = () => [
    { type: HttpClient },
    { type: ParameterService }
];
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], AuthService.prototype, "selectedAppUpdated", void 0);
AuthService = __decorate([ __metadata("design:paramtypes", [HttpClient,
        ParameterService])
], AuthService);

class ApplicationDesc {
    constructor(area, name, url, type, showTile, requireTenant, multiTenant, loadMultiTenantsFromStorage, selectAllMultiTenantsByDefault, id, options, icon, logoutUrl, languageProperties, isFavourite) {
        this.area = area;
        this.name = name;
        this.url = url;
        this.type = type;
        this.showTile = showTile;
        this.requireTenant = requireTenant;
        this.multiTenant = multiTenant;
        this.loadMultiTenantsFromStorage = loadMultiTenantsFromStorage;
        this.selectAllMultiTenantsByDefault = selectAllMultiTenantsByDefault;
        this.id = id;
        this.url = url;
        this.icon = icon;
        this.logoutUrl = logoutUrl;
        this.options = options;
        this.languageProperties = languageProperties;
        this.isFavourite = isFavourite;
    }
    static compareIt(a, b) {
        return (a.id === b.id &&
            a.area === b.area &&
            a.icon === b.icon &&
            a.logoutUrl === b.logoutUrl &&
            a.options === b.options &&
            a.requireTenant === b.requireTenant &&
            a.multiTenant === b.multiTenant &&
            a.showTile === b.showTile &&
            a.type === b.type &&
            a.url === b.url &&
            a.isFavourite === b.isFavourite);
    }
}
class LanguageProperties {
    constructor(ltag, larea, lname) {
        this.ltag = ltag;
        this.larea = larea;
        this.lname = lname;
        this.tag = ltag;
        this.area = larea;
        this.name = lname;
    }
    static compareIt(a, b) {
        return a.tag === b.tag && a.area === b.area && a.name === b.name;
    }
}
let ApplicationService = class ApplicationService {
    constructor(http, parameterService) {
        this.http = http;
        this.parameterService = parameterService;
        this.serviceUrl = '/rest/energy/portal/apps';
        this.applicationState = new Subject();
        this.messagePublishEvent = new EventEmitter();
        this.baseUrl = window.location.host;
        // call update to set an empty default application
        this.updateAppList([new ApplicationDesc('', '', this.baseUrl, 'home', false, false)]);
    }
    /**
     * Get application base properties.
     */
    getApplicationBaseProperties() {
        return this.http.request('GET', this.serviceUrl + '/logo', {
            body: { ignoreAuthModule: false },
            headers: { Accept: 'text/plain, */*' }
        });
    }
    /**
     * Get the observable applicationState.
     */
    getApplicationState() {
        return this.applicationState;
    }
    /**
     * Return the currently selected application.
     */
    getSelectedApplication() {
        return this.selected;
    }
    /**
     * Get the list of applications from the back-end.
     */
    getApplicationList() {
        return this.http
            .request('GET', this.serviceUrl + '/applications', {
            body: { ignoreAuthModule: false },
            headers: { Accept: 'application/json, text/plain, */*' }
        })
            .pipe(
        // retry(3),
        map((response) => this.updateAppList(response)));
    }
    /**
     * Set (in case it's missing from the application registry) or override the multiTenant property.
     * @param multiTenant whether or not the current application is multiTenant
     * @param loadFromStorage whether or not the frame-module-lib shall try to load selected tenants from local
     * storage - only relevant if multiTenant
     * @param selectAllByDefault whether or not the frame-module-lib shall select all tenants by default
     * (if no stored list was found) - only relevant if multiTenant
     */
    setMultiTenant(multiTenant, loadFromStorage, selectAllByDefault) {
        this.getApplicationState().subscribe(state => {
            this.selected.multiTenant = multiTenant;
            this.selected.loadMultiTenantsFromStorage = loadFromStorage ? loadFromStorage : false;
            this.selected.selectAllMultiTenantsByDefault = selectAllByDefault ? selectAllByDefault : false;
        });
    }
    /**
     * Update the list of apps (normalize URLs) and determine the currently selected app.
     * @param data array of application descriptions
     */
    updateAppList(data) {
        if (data !== undefined && !this.compareApps(this.apps, data)) {
            if (data.length > 0 && data[0].type !== 'home') {
                data.unshift(this.apps[0]);
            }
            for (let i = 0; i < data.length; i++) {
                if (data[i].url.startsWith('/', 0)) {
                    data[i].url = this.baseUrl + data[i].url;
                }
                if (data[i].type === 'internal') {
                    data[i].url =
                        this.apps[0].url +
                            '/#/embedded?site=' +
                            encodeURIComponent(data[i].url)
                                .replace(/%3A/g, ':')
                                .replace(/%2C/g, ',');
                }
                // remove ports
                const ports = [':80/', ':443/'];
                for (let j = 0; j < ports.length; j++) {
                    if (data[i].url.indexOf(ports[j]) !== -1) {
                        data[i].url = data[i].url.replace(ports[j], '/');
                    }
                }
                // if a home app exists, put it on index 0 and overwrite the default home app
                // must be done at the end to prevent index problems when splicing the entry
                if (i > 0 && data[i].type === 'home') {
                    data[0] = data[i];
                    data.splice(i, 1);
                    i--;
                }
            }
            // sort the array of apps by their areas and names in ascending order,
            // excluding the home app at index 0
            if (data.length > 1) {
                const sortApps = data.slice(1);
                data = data.slice(0, 1);
                sortApps.sort((firstElement, secondElement) => {
                    const firstElementArea = firstElement.area.toLowerCase(), secondElementArea = secondElement.area.toLowerCase();
                    if (firstElementArea < secondElementArea) {
                        // sort ascending
                        return -1;
                    }
                    if (firstElementArea > secondElementArea) {
                        return 1;
                    }
                    const firstElementName = firstElement.name.toLowerCase(), secondElementName = secondElement.name.toLowerCase();
                    if (firstElementName < secondElementName) {
                        // sort ascending
                        return -1;
                    }
                    if (firstElementName > secondElementName) {
                        return 1;
                    }
                    return 0; // default: no sorting
                });
                data = data.concat(sortApps);
            }
            this.apps = data;
            this.selected = this.parseUrl();
            // prevent null pointer exceptions in case no matching app has been found:
            if (this.selected === null || this.selected === undefined) {
                this.selected = this.apps[0];
            }
            this.applicationState.next({ selectedApp: this.selected });
            return data;
        }
    }
    /**
     * Find the most fitting app for current URL -> it's the selected one.
     */
    parseUrl() {
        // compare protocol host post path and embedded parameter!
        let match = null;
        let domain = window.location.href.split('#')[0];
        domain = domain.split('?')[0];
        if (domain[domain.length - 1] === '/') {
            domain = domain.substring(0, domain.length - 1);
        }
        // Search for embedded first
        // var params = $location.search();
        // var path = $location.path();
        // if (path === '/embedded' && params.site) {
        //   domain = decodeURIComponent(params.site);
        // }
        // Search for best match of non embedded
        let best = null;
        // let appsSortedByURLLength = this.apps;
        const appsSortedByURLLength = Object.assign([], this.apps);
        // rearrange order of elements in array by url length
        appsSortedByURLLength.sort(function (firstElement, secondElement) {
            const firstElementUrlLength = firstElement.url.length;
            const secondElementUrlLength = secondElement.url.length;
            return secondElementUrlLength - firstElementUrlLength;
        });
        for (let i = 0; !match && i < appsSortedByURLLength.length; i++) {
            let found = domain.indexOf(decodeURIComponent(appsSortedByURLLength[i].url));
            if (found >= 0) {
                // it fits
                if (!best) {
                    best = appsSortedByURLLength[i];
                }
                found = appsSortedByURLLength[i].url.indexOf(window.location.href); // compare with full path including parameters
                if (found >= 0) {
                    // full match
                    match = appsSortedByURLLength[i];
                }
            }
        }
        if (!match) {
            match = best;
        }
        return match;
    }
    /**
     * Get list of supported languages.
     *
     * // TODO: remove and use languageProperties of currently selected application?
     */
    getLanguageProperties() {
        if (this.globalLanguages) {
            return of(this.globalLanguages);
        }
        if (!this.languageObservable) {
            this.languageObservable = new Observable((observer) => {
                this.http.request('GET', this.serviceUrl + '/languages', {
                    body: { ignoreAuthModule: false },
                    headers: { Accept: 'text/plain, */*' },
                    responseType: 'text'
                }).subscribe(res => {
                    this.globalLanguages = res;
                    observer.next(res);
                    observer.complete();
                }, err => {
                    console.log(err);
                    observer.error(err);
                });
            });
            return this.languageObservable;
        }
    }
    /**
     * Update the list of apps with the translated app and area names.
     * @param lang the target language
     */
    updateTranslatedAppNamesAndAreas(lang) {
        for (let i = 0; i < this.apps.length; i++) {
            if (this.apps[i].languageProperties) {
                let langPropertiesArr = this.apps[i].languageProperties;
                // convert JSON string to object (spring boot back-end)
                if (typeof langPropertiesArr === 'string') {
                    langPropertiesArr = this.convertJSONStrToObject(langPropertiesArr);
                }
                let match = false;
                for (let j = 0; j < langPropertiesArr.length && !match; j++) {
                    if (langPropertiesArr[j].tag) {
                        let langCode = langPropertiesArr[j].tag;
                        if (langPropertiesArr[j].tag.indexOf('_') < 0) {
                            langCode = langPropertiesArr[j].tag + '_' + lang.split('_')[1];
                        }
                        if (langCode === lang) {
                            this.apps[i].name = langPropertiesArr[j].name;
                            this.apps[i].area = langPropertiesArr[j].area;
                            match = true;
                        }
                    }
                }
            }
        }
        return this.apps;
    }
    /**
     * Select the application (with a tenant if required.
     * @param app the app to select
     */
    selectAppWithTenant(app) {
        // Check and get tenant
        if (app.requireTenant) {
            // NOTE: This is not needed anymore, tenant selection happens inside the new app
            // TODO: rework / rename this function
            // this.tenantService.openTenantSelection(app.name).subscribe(v => {
            //     window.location.href = this.parameterService.composeUrl(app);
            // });
            window.location.href = this.parameterService.composeUrl(app);
        }
        else {
            window.location.href = this.parameterService.composeUrl(app);
        }
    }
    compareApps(oldApps, newApps) {
        if (oldApps === undefined || newApps === undefined) {
            return false;
        }
        let appEquals = false;
        for (let i = 0; i < oldApps.length; i++) {
            const oldApp = oldApps[i];
            for (let j = 0; j < newApps.length; j++) {
                const newApp = newApps[j];
                if (newApp.name === oldApp.name) {
                    appEquals = ApplicationDesc.compareIt(oldApp, newApp);
                    break;
                }
            }
            if (!appEquals) {
                break;
            }
        }
        return appEquals;
    }
    /**
     * Emit messages to other components.
     * @return message publish event.
     */
    getMessageEmitter() {
        return this.messagePublishEvent;
    }
    /**
     * Publish messages to other components.
     * @param message message to be published.
     */
    publishMessage(message) {
        this.messagePublishEvent.emit(message);
    }
    /**
     * Convert a JSON string to a JSON object.
     * @param str JSON string to be converted
     * @return JSON object.
     */
    convertJSONStrToObject(str) {
        let jsonStrAsObj;
        try {
            jsonStrAsObj = JSON.parse(str);
        }
        catch (e) {
            return null;
        }
        return jsonStrAsObj;
    }
};
ApplicationService.ɵfac = function ApplicationService_Factory(t) { return new (t || ApplicationService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(ParameterService)); };
ApplicationService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ApplicationService, factory: ApplicationService.ɵfac });
ApplicationService.ctorParameters = () => [
    { type: HttpClient },
    { type: ParameterService }
];
ApplicationService = __decorate([ __metadata("design:paramtypes", [HttpClient, ParameterService])
], ApplicationService);

let KiNumberPipe = class KiNumberPipe {
    constructor(translateService) {
        this.translateService = translateService;
        this.updateLang();
    }
    updateLang() {
        if (this.currLang === null || this.currLang === undefined || this.currLang !== this.translateService.currentLang) {
            this.currLang = this.translateService.currentLang;
        }
    }
    transform(number, minInt = 1, minFrac = 0, maxFrac = 2, numFormatPattern = NumberFormatStyle.Decimal) {
        const pattern = minInt.toString() + '.' + minFrac.toString() + '-' + maxFrac.toString();
        this.updateLang();
        const lang = this.currLang ? this.currLang : 'en';
        if (numFormatPattern === NumberFormatStyle.Decimal) {
            this.lastValue = new DecimalPipe(lang).transform(number, pattern, lang);
        }
        else if (numFormatPattern === NumberFormatStyle.Currency) {
            const currencySymbol = getLocaleCurrencyName(lang);
            this.lastValue = new CurrencyPipe(lang).transform(number, currencySymbol, 'symbol', pattern, this.currLang);
        }
        else if (numFormatPattern === NumberFormatStyle.Percent) {
            this.lastValue = new PercentPipe(lang).transform(number, pattern, lang);
        }
        else if (numFormatPattern === NumberFormatStyle.Scientific) {
            this.lastValue = number.toPrecision(maxFrac).toString();
        }
        return this.lastValue;
    }
};
KiNumberPipe.ɵfac = function KiNumberPipe_Factory(t) { return new (t || KiNumberPipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.TranslateService)); };
KiNumberPipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "kiNumber", type: KiNumberPipe, pure: false });
KiNumberPipe.ctorParameters = () => [
    { type: TranslateService }
];
KiNumberPipe = __decorate([ __metadata("design:paramtypes", [TranslateService])
], KiNumberPipe);

let KiDatePipe = class KiDatePipe {
    constructor(translateService) {
        this.translateService = translateService;
        this.updateLang();
    }
    updateLang() {
        if (this.currLang === null || this.currLang === undefined || this.currLang !== this.translateService.currentLang) {
            this.currLang = this.translateService.currentLang;
        }
    }
    transform(date, datePattern = 'mediumDate') {
        this.updateLang();
        if (this.currLang === this.lastLang && date === this.lastDate && datePattern === this.lastPattern) {
            return this.lastValue;
        }
        const lang = this.currLang ? this.currLang : 'en'; // fallback in case there is something wrong with translateService settings
        this.lastValue = new DatePipe(lang).transform(date, datePattern);
        this.lastDate = date;
        this.lastLang = lang;
        this.lastPattern = datePattern;
        return this.lastValue;
    }
};
KiDatePipe.ɵfac = function KiDatePipe_Factory(t) { return new (t || KiDatePipe)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.TranslateService)); };
KiDatePipe.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "kiDate", type: KiDatePipe, pure: false });
KiDatePipe.ctorParameters = () => [
    { type: TranslateService }
];
KiDatePipe = __decorate([ __metadata("design:paramtypes", [TranslateService])
], KiDatePipe);

/**
 * Interface for mapping language name to tag.
 */
class Language {
}
var DateTimeFormat;
(function (DateTimeFormat) {
    DateTimeFormat[DateTimeFormat["short"] = 0] = "short";
    DateTimeFormat[DateTimeFormat["medium"] = 1] = "medium";
    DateTimeFormat[DateTimeFormat["long"] = 2] = "long";
    DateTimeFormat[DateTimeFormat["full"] = 3] = "full";
    DateTimeFormat[DateTimeFormat["shortDate"] = 4] = "shortDate";
    DateTimeFormat[DateTimeFormat["mediumDate"] = 5] = "mediumDate";
    DateTimeFormat[DateTimeFormat["longDate"] = 6] = "longDate";
    DateTimeFormat[DateTimeFormat["fullDate"] = 7] = "fullDate";
    DateTimeFormat[DateTimeFormat["shortTime"] = 8] = "shortTime";
    DateTimeFormat[DateTimeFormat["mediumTime"] = 9] = "mediumTime";
    DateTimeFormat[DateTimeFormat["longTime"] = 10] = "longTime";
    DateTimeFormat[DateTimeFormat["fullTime"] = 11] = "fullTime";
})(DateTimeFormat || (DateTimeFormat = {}));
class CalendarLocale {
}
let LanguageService = class LanguageService {
    constructor(parameterService, localStorage, translate) {
        this.parameterService = parameterService;
        this.localStorage = localStorage;
        this.translate = translate;
        this.initializedFromBackend = false;
        this.currentLanguage = { name: '', tag: '' };
        this.calendarLocale = new CalendarLocale();
        registerLocaleData(localeDataDe, 'de');
        // set default
        this.selectableLanguages = [
            {
                name: 'Deutsch',
                tag: 'de_DE'
            },
            {
                name: 'English',
                tag: 'en_GB'
            }
        ];
        this.languageChanged = new EventEmitter();
        this.displaySelectionDialog = new EventEmitter();
        this.languageChangedSubject = new Subject();
        this.languageChangedObservable$ = this.languageChangedSubject.asObservable();
        this.calendarLocaleSubject = new BehaviorSubject(null);
        this.calendarLocaleObservable = this.calendarLocaleSubject.asObservable();
        this.initLanguage();
    }
    /**
     * Get the selectable languages.
     * @returns array with selectable languages
     */
    getSelectableLanguages() {
        return this.selectableLanguages;
    }
    /**
     * Set the selectable languages.
     * @param array with selectable languages
     */
    setSelectableLanguages(languages) {
        this.selectableLanguages = languages;
    }
    /**
     * Get the selected language.
     * @returns the selected language (tag)
     * */
    getLanguage() {
        if (this.currentLanguage === undefined || this.currentLanguage === null) {
            this.initLanguage();
        }
        return this.currentLanguage.tag;
    }
    /**
     * Set the language.
     * @param newLang the current language tag
     */
    setLanguage(newLang) {
        if (this.currentLanguage && this.currentLanguage.tag === newLang) {
            return;
        }
        this.translate.setDefaultLang(newLang);
        const supportedLangs = this.getTagsOfSupportedLang();
        // indicates the match language browser <-> app
        // langMatch = newLang in case browser language or app language is set
        let langMatch = newLang;
        if (supportedLangs.indexOf(newLang) < 0) {
            // case: newLang is not supported
            // the newLang has to be set from browser language:
            // Case 1: browser lang-tag has the right format(xx_YY), but is not supported -> filter the lang family (xx)
            // Case 2: browser lang-tag has the format like 'xx' -> take it as lang family
            const newLangFamily = newLang.indexOf('_') < 0 ? newLang.split('_')[0] : newLang;
            langMatch = undefined;
            supportedLangs.map((langTag) => {
                if (langMatch === undefined) {
                    // for case 1
                    const langFamily = langTag.split('_');
                    // find out if lang family is supported
                    if (langFamily[0].toLowerCase() === newLangFamily.toLowerCase()) {
                        // in case the lang family is supported -> set the complete lang-tag
                        langMatch = langTag;
                    }
                }
            });
        }
        // no match found
        if (langMatch === undefined) {
            // use fallback language
            langMatch = 'en_GB';
        }
        // update current lang
        this.currentLanguage.tag = langMatch;
        this.translate.use(this.currentLanguage.tag);
        // update country specific separators
        try {
            if (this.currentLanguage) {
                let localeLang = '';
                if (this.currentLanguage.tag.indexOf('_') > 0) {
                    localeLang = this.currentLanguage.tag.split('_')[0];
                }
                else {
                    localeLang = this.currentLanguage.tag;
                }
                // registerLocaleData(localeDataDe)
                this.prevDecimalSeparator = getLocaleNumberSymbol(localeLang, NumberSymbol.Decimal);
                this.prevGroupSeparator = getLocaleNumberSymbol(localeLang, NumberSymbol.Group);
            }
        }
        catch (e) {
            console.log(e);
        }
        if (this.initializedFromBackend) {
            // update parameters in URL
            this.parameterService.setValue('lang', newLang);
            this.parameterService.toLocation();
            // backup language in the local storage only if this match is a varified language from backend
            localStorage.setItem('userLanguage', newLang);
        }
        this.updateCalendarLocale();
        this.languageChanged.emit(this.currentLanguage.tag);
        this.languageChangedSubject.next(this.currentLanguage.tag);
    }
    /**
     * Get the tags of supported languages.
     * @returns an array with the supported languages
     */
    getTagsOfSupportedLang() {
        const supportedLangs = [];
        this.getSelectableLanguages().map((selectableLang) => {
            supportedLangs.push(selectableLang.tag);
        });
        return supportedLangs;
    }
    /**
     * Initialize and validify the current (starting) language.
     * @param initializedFromBackend Whether or not the available languages have been initialized from backend
     */
    initLanguage(initializedFromBackend) {
        if (initializedFromBackend === true) {
            this.initializedFromBackend = initializedFromBackend;
        }
        let newLang = '';
        // case: init from url
        newLang = this.validateLanguage(this.parameterService.getValue('lang'));
        // case: init from local storage
        if (!newLang && this.localStorage) {
            const localStorageLang = localStorage.getItem('userLanguage');
            newLang = this.validateLanguage(localStorageLang);
        }
        // case: init from browser language
        if (!newLang) {
            const browserLang = window.navigator.language;
            newLang = this.validateLanguage(browserLang);
        }
        // case: language could not be set by any means
        if (!newLang) {
            if (this.initializedFromBackend) {
                // show selection dialog if fully initialized
                this.displaySelectionDialog.emit(this.selectableLanguages);
            }
            // set last resort default
            newLang = 'en_GB';
        }
        this.setLanguage(newLang);
    }
    /**
     * Analyse the given language tag, normalize if necessary and needed, then check if
     * the language is actually supported by the current application.
     * @param lang a potential new Language for the UI
     * @returns the language tag if it is valid, empty string if not
     */
    validateLanguage(lang) {
        if (!lang) {
            return '';
        }
        const supportedLangs = this.getTagsOfSupportedLang();
        let language = '';
        if (supportedLangs.indexOf(lang) > -1) {
            // case: app supports this language
            language = lang;
        }
        else if (lang.indexOf('-') > -1) {
            // case: app supports language, but the format is not conform and has to be adapted
            language = lang.replace('-', '_');
        }
        else {
            // case: language is not fully supported (missing country code most likely)
            // check if the language code is included in a single supported language
            const results = supportedLangs.filter(a => a.includes(lang));
            if (results.length === 1) {
                // automatically select this match
                language = results[0];
            }
            else {
                // do not select if there are multiple country hits for this language. the user will
                // have to select his desired language in a dialog
                return '';
            }
        }
        // return this language if it is valid and selectable
        return this.selectableLanguages.filter((data) => data.tag === language).length > 0 ? language : '';
    }
    /**
     * Update the primeNG calendar localization and update subscribers of calendarLocaleSubject.
     */
    updateCalendarLocale() {
        this.translate
            .get([
            'firstDayOfWeek',
            'dayNames',
            'dayNamesShort',
            'dayNamesMin',
            'monthNames',
            'monthNamesShort',
            'today',
            'clear'
        ])
            .subscribe((value) => {
            if (value) {
                this.calendarLocale.firstDayOfWeek = value['firstDayOfWeek'];
                this.calendarLocale.dayNames = value['dayNames'];
                this.calendarLocale.dayNamesShort = value['dayNamesShort'];
                this.calendarLocale.dayNamesMin = value['dayNamesMin'];
                this.calendarLocale.monthNames = value['monthNames'];
                this.calendarLocale.monthNamesShort = value['monthNamesShort'];
                this.calendarLocale.today = value['today'];
                this.calendarLocale.clear = value['clear'];
                this.calendarLocale.dateFormat = this.getMappedDateFormatToPrimeNG();
                this.calendarLocaleSubject.next(this.calendarLocale);
            }
        });
    }
    /**
     * Get the localized strings for the calendar control (PrimeNG).
     * @returns the object with the calendar locales
     * @deprecated subscribe to @calendarLocaleSubject instead, to be able to update your calendar dynamically on language changes
     */
    getCalendarLocale() {
        return this.calendarLocale;
    }
    /**
     *Get localized numbers.
     * @param value the value
     * @param minInt the minimum
     * @param minFrac the min fraction
     * @param maxFrac the max fraction
     * @param numFormatStyle the number format style
     */
    getLocalizedNumber(value, minInt, minFrac, maxFrac, numFormatStyle) {
        if (minInt === undefined) {
            minInt = 1;
        }
        if (minFrac === undefined) {
            minFrac = 0;
        }
        if (maxFrac === undefined) {
            maxFrac = 2;
        }
        if (numFormatStyle === undefined) {
            numFormatStyle = NumberFormatStyle.Decimal;
        }
        return new KiNumberPipe(this.translate).transform(value, minInt, minFrac, maxFrac, numFormatStyle);
    }
    /**
     * Get the localized date.
     * @param date: the date
     * @param dateTimeFormat: the dateTime format
     * @returns the localized date
     */
    getLocalizedDate(date, dateTimeFormat) {
        if (dateTimeFormat === undefined) {
            dateTimeFormat = 'mediumDate';
        }
        return new KiDatePipe(this.translate).transform(date, dateTimeFormat);
    }
    /**
     * Get a localized number as string.
     value: number, minInt: number, minFrac: number, maxFrac: number, numFormatStyle: NumberFormatStyle
     */
    getLocalizedNumberAsString(value, minInt, minFrac, maxFrac, numFormatStyle) {
        const localizedNo = this.getLocalizedNumber(value, minInt, minFrac, maxFrac, numFormatStyle);
        return localizedNo;
    }
    /**
     * Convert a localized number (as string) to a number object.
     * @param value localized number as string
     * @returns number object
     */
    getLocalizedStringToNumber(value) {
        value = value
            .replace(this.prevGroupSeparator, '')
            .replace(this.prevDecimalSeparator, '.');
        return parseFloat(value);
    }
    /**
     * Convert the Angular date format to PrimeNG date format.
     * @returns PrimeNG date format
     * @param width optional formatWidth of the dateFormat
     * @deprecated subscribe to @calendarLocaleSubject and take the dateFormat from the calendarLocale
     */
    getMappedDateFormatToPrimeNG(width) {
        /* Mapping:
          yyyy -> yy else y
          MMMM -> MM, MMM -> M, MM -> mm, M -> m
          dd -> dd, d -> d
          EEEE -> DD, E & EE & EE -> D
        */
        const formatWidth = width ? width : FormatWidth.Short;
        let dateFormat = getLocaleDateFormat(this.currentLanguage.tag, formatWidth);
        if (dateFormat.match(/(yyyy)/)) {
            dateFormat = dateFormat.replace(/(yyyy)/, 'yy');
        }
        else if (dateFormat.match(/y/)) {
            if (this.currentLanguage.tag === 'en_GB') {
                dateFormat = dateFormat.replace(/(y)+/g, 'yy');
            }
            else {
                dateFormat = dateFormat.replace(/(y)+/g, 'y');
            }
        }
        if (dateFormat.match(/(EEEE)/)) {
            dateFormat = dateFormat.replace(/(EEEE)/, 'DD');
        }
        else if (dateFormat.match(/E/)) {
            dateFormat = dateFormat.replace(/(E)+/g, 'D');
        }
        if (dateFormat.match(/(MMMM)/)) {
            dateFormat = dateFormat.replace(/(MMMM)/, 'MM');
        }
        else if (dateFormat.match(/(MMM)/)) {
            dateFormat = dateFormat.replace(/(MMM)/, 'M');
        }
        else if (dateFormat.match(/(MM)/)) {
            dateFormat = dateFormat.replace(/(MM)/, 'mm');
        }
        else if (dateFormat.match(/(M)/)) {
            dateFormat = dateFormat.replace(/(M)/, 'm');
        }
        return dateFormat;
    }
};
LanguageService.ɵfac = function LanguageService_Factory(t) { return new (t || LanguageService)(ɵngcc0.ɵɵinject(ParameterService), ɵngcc0.ɵɵinject('LOCALSTORAGE'), ɵngcc0.ɵɵinject(ɵngcc4.TranslateService)); };
LanguageService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: LanguageService, factory: LanguageService.ɵfac });
LanguageService.ctorParameters = () => [
    { type: ParameterService },
    { type: undefined, decorators: [{ type: Inject, args: ['LOCALSTORAGE',] }] },
    { type: TranslateService }
];
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], LanguageService.prototype, "languageChanged", void 0);
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], LanguageService.prototype, "displaySelectionDialog", void 0);
LanguageService = __decorate([ __param(1, Inject('LOCALSTORAGE')),
    __metadata("design:paramtypes", [ParameterService, Object, TranslateService])
], LanguageService);

let WindowRef = class WindowRef {
    constructor() { }
    getWindowReference() {
        return window;
    }
};
WindowRef.ɵfac = function WindowRef_Factory(t) { return new (t || WindowRef)(); };
WindowRef.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: WindowRef, factory: WindowRef.ɵfac });
WindowRef = __decorate([ __metadata("design:paramtypes", [])
], WindowRef);
let HelpService = class HelpService {
    constructor(authService, httpClient, winRef, route, router, langSrv) {
        this.authService = authService;
        this.httpClient = httpClient;
        this.winRef = winRef;
        this.route = route;
        this.router = router;
        this.langSrv = langSrv;
        this.baseUrl = '/rest/energy/portal/helpurl/?';
        this.version = '';
        this.path = 'portal';
    }
    getContext() {
        let context = '';
        let hashValue = this.route.snapshot.fragment
            ? this.route.snapshot.fragment
            : '';
        if (hashValue !== '') {
            if (hashValue.indexOf('#') > -1) {
                hashValue = hashValue.split('#')[1];
            }
            if (hashValue.indexOf('?') > -1) {
                hashValue = hashValue.split('?')[0];
            }
            if (hashValue.startsWith('/')) {
                hashValue = hashValue.slice(1);
            }
            if (hashValue.endsWith('/')) {
                hashValue = hashValue.slice(0, -1);
            }
            if (hashValue.length - hashValue.replace(/\//g, '').length > 1) {
                hashValue = hashValue.replace(/\//g, '_');
            }
            else {
                hashValue = hashValue.replace(/\//g, '');
            }
            context = hashValue;
        }
        else {
            let url = this.router.url;
            if (url.indexOf('?') > -1) {
                url = url.split('?')[0];
            }
            if (!url) {
                url = '';
            }
            else if (url.startsWith('/')) {
                url = url.substr(1);
            }
            context = url;
        }
        return context;
    }
    /**
     * call
     */
    call(context) {
        if (!context) {
            context = this.getContext();
        }
        let lang;
        lang = this.langSrv.getLanguage();
        if (lang === undefined || lang === null || lang === '') {
            lang = 'de_de';
        }
        this.helpWindow = this.winRef.getWindowReference().open();
        this.authService.getAuthInfo().subscribe((authInfo) => {
            const user = authInfo.username;
            const queryParams = new HttpParams()
                .set('path', this.path)
                .set('version', this.version)
                .set('lang', lang.toLocaleLowerCase())
                .set('user', user)
                .set('tenant', '')
                .set('contentpath', 'index_content.php')
                .set('context', context);
            let helpUrl = '';
            this.httpClient
                .get(this.baseUrl, {
                params: queryParams,
                observe: 'response',
                withCredentials: true
            })
                .subscribe((response) => {
                const headers = response.headers;
                helpUrl = headers.get('helpurl');
                const iFrame = document.createElement('iframe');
                iFrame.setAttribute('style', 'display: none; height: 0px');
                iFrame.setAttribute('src', headers.get('requesttokenurl'));
                const helpWin = this.helpWindow;
                iFrame.onload = function () {
                    helpWin.location.href = helpUrl;
                    helpWin.focus();
                };
                document.body.appendChild(iFrame);
            }, (helpError) => {
                const helpWin = this.helpWindow;
                helpWin.location.href = helpError.headers.get('helpurl');
                helpWin.focus();
            });
        }, 
        // error case of getLoginInfo
        (error) => {
            /*         const callUrl =
              this.baseUrl +
              'path=' +
              this.path +
              '&version=' +
              this.version +
              '&lang=' +
              lang.toLocaleLowerCase() +
              '&user=username' +
              '&tenant=' +
              '&contentpath=index_content.php'; */
            const queryParams = new HttpParams()
                .set('path', this.path)
                .set('version', this.version)
                .set('lang', lang.toLocaleLowerCase())
                .set('user', 'username')
                .set('tenant', '')
                .set('contentpath', 'index_content.php')
                .set('context', context);
            this.httpClient
                .get(this.baseUrl, {
                params: queryParams,
                observe: 'response',
                withCredentials: true
            })
                .subscribe((response) => {
                const helpWin = this.helpWindow;
                helpWin.location.href = response.headers.get('helpurl');
                helpWin.focus();
            }, (helpError) => {
                const helpWin = this.helpWindow;
                helpWin.location.href = helpError.headers.get('helpurl');
                helpWin.focus();
            });
        });
    }
    setVersion(newVersion) {
        this.version = newVersion;
    }
    setPath(newPath) {
        this.path = newPath;
    }
    setBackendLocation(baseUrl) {
        if (baseUrl.endsWith('/')) {
            baseUrl = baseUrl.slice(0, -1);
        }
        const restCallUrl = baseUrl + this.baseUrl;
        this.baseUrl = restCallUrl;
    }
};
HelpService.ɵfac = function HelpService_Factory(t) { return new (t || HelpService)(ɵngcc0.ɵɵinject(AuthService), ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(WindowRef), ɵngcc0.ɵɵinject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(LanguageService)); };
HelpService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: HelpService, factory: HelpService.ɵfac });
HelpService.ctorParameters = () => [
    { type: AuthService },
    { type: HttpClient },
    { type: WindowRef },
    { type: ActivatedRoute },
    { type: Router },
    { type: LanguageService }
];
HelpService = __decorate([ __metadata("design:paramtypes", [AuthService,
        HttpClient,
        WindowRef,
        ActivatedRoute,
        Router,
        LanguageService])
], HelpService);

// Theme interface
class Theme {
}
// Theme service to switch to onother theme
let ThemeService = class ThemeService {
    constructor(parameterService) {
        this.parameterService = parameterService;
        this.urlParamTheme = 'theme';
        this.newThemes = [
            {
                name: 'Corporate Light',
                tag: 'theme-corporate-light',
                key: 'corporate-light'
            },
            {
                name: 'Corporate Dark',
                tag: 'theme-corporate-dark',
                key: 'corporate-dark'
            }
        ];
        this.themes = [
            {
                name: 'Corporate Light',
                tag: 'theme-corporate-light',
                key: 'cooperate-light'
            },
            {
                name: 'Corporate Dark',
                tag: 'theme-corporate-dark',
                key: 'cooperate-dark'
            },
            { name: 'Oceanblue', tag: 'theme-oceanblue', key: 'oceanblue' },
            { name: 'Rubyred', tag: 'theme-rubyred', key: 'rubyred' }
        ];
        const themeKey = parameterService.getValue(this.urlParamTheme);
        if (themeKey) {
            this.setTheme(themeKey);
        }
        else {
            let theme = localStorage.getItem('theme');
            this.setTheme(theme);
        }
    }
    getThemes() {
        return this.themes;
    }
    setTheme(aTheme) {
        let theme;
        if (typeof aTheme === 'string') {
            theme = this.themes.find((ctheme) => ctheme.key === aTheme);
        }
        else {
            theme = aTheme;
        }
        if (theme === undefined || theme === null) {
            // check the new theme names
            theme = this.newThemes.find((ctheme) => ctheme.key === aTheme);
            if (theme === undefined || theme === null) {
                return;
            }
        }
        const themeLinks = document.getElementsByName('kisters-theme');
        Array.from(themeLinks).forEach((element) => {
            const pathItems = element.href.split('/');
            pathItems[pathItems.length - 1] = theme.tag + '.css';
            element.href = pathItems.join('/');
        });
        this.activeTheme = theme;
        this.parameterService.setValue(this.urlParamTheme, theme.key);
        localStorage.setItem('theme', theme.key);
    }
};
ThemeService.ɵfac = function ThemeService_Factory(t) { return new (t || ThemeService)(ɵngcc0.ɵɵinject(ParameterService)); };
ThemeService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: ThemeService, factory: ThemeService.ɵfac });
ThemeService.ctorParameters = () => [
    { type: ParameterService }
];
ThemeService = __decorate([ __metadata("design:paramtypes", [ParameterService])
], ThemeService);

let TenantService = class TenantService {
    constructor(http, parameterService, applicationService, translateService) {
        this.http = http;
        this.parameterService = parameterService;
        this.applicationService = applicationService;
        this.translateService = translateService;
        this.tenantBasePath = '/rest/energy/portal/user/tenants';
        this.tenantSelectionDlgState = new Subject();
        this.tenantState = new Subject();
        this.checkInitialState();
    }
    /**
     * Check the parameters for any selected tenant and apply accordingly, if possible. Open tenant selection dialog if necessary.
     */
    checkInitialState() {
        this.applicationService.getApplicationState().subscribe((app) => {
            const selectedApplication = app.selectedApp;
            // a selected application (current application) is mandatory for this service to work
            if (!selectedApplication) {
                return;
            }
            // if requireTenant is false (while multiTenant is false as well), return - this service is not needed
            if (!selectedApplication.requireTenant &&
                !selectedApplication.multiTenant) {
                return;
            }
            // get available tenants
            this.getTenants().subscribe((ts) => {
                this.tenantList = ts;
                // if no tenants could be retrieved from backend, show error message
                if (this.tenantList === null ||
                    this.tenantList === undefined ||
                    this.tenantList.length < 1) {
                    this.openTenantSelection(true, this.translateService.instant('TENANT_LOAD_ERROR'));
                    return;
                }
                // if there is only one tenant, select it
                if (this.tenantList.length === 1) {
                    this.selectTenant(this.tenantList);
                    return;
                }
                // if the application is multiTenant, check optional settings
                if (selectedApplication.multiTenant) {
                    // if all tenants should be selected, do that and return
                    if (selectedApplication.selectAllMultiTenantsByDefault) {
                        this.selectTenant(this.tenantList);
                        return;
                    }
                    // if selected tenants shall be loaded from storage, try that
                    if (selectedApplication.loadMultiTenantsFromStorage) {
                        const storedList = this.loadTenantsFromLocalStorage();
                        if (storedList !== undefined &&
                            storedList !== null &&
                            storedList.length > 0) {
                            this.selectTenant(storedList);
                            return;
                        }
                    }
                }
                // if nothing could be selected yet, try to get selected tenant from parameterService
                const preSelectedTenant = this.parameterService.getValue('tenant');
                if (preSelectedTenant) {
                    // if the tenant from url is available for current application -> select
                    if (this.tenantList.includes(preSelectedTenant)) {
                        this.selectTenant([preSelectedTenant]);
                        return;
                    }
                }
                // if still nothing is currently selected or can be selected, prompt user (with mandatory flag)
                this.openTenantSelection(true);
            });
        });
    }
    /**
     *  Open tenant selection dialog.
     * @param mandatory whether or not the user MUST select at least one tenant.
     * @param error optional error message to be displayed to the user
     */
    openTenantSelection(mandatory, error) {
        this.tenantSelectionDlgState.next({ open: true, mandatory, error });
        return this.tenantSelectionDlgState;
    }
    /**
     * Close tenant selection dialog.
     */
    closeTenantSelection() {
        this.tenantSelectionDlgState.next({ open: false, mandatory: false });
    }
    /**
     * Tenant selection dialog state.
     */
    getTenantSelectionDlgState() {
        return this.tenantSelectionDlgState;
    }
    /**
     * Get the tenants from the back-end.
     * @returns an Array of type string with the tenants
     */
    getTenants() {
        return this.http.get(this.tenantBasePath);
    }
    /**
     * Select an array of tenants - may contain only one (for single tenant applications).
     * @param tenants the array of tenants
     */
    selectTenant(tenants) {
        let tenant;
        const multiTenant = this.applicationService.getSelectedApplication()
            .multiTenant;
        if (multiTenant) {
            tenants.sort();
            tenant = tenants.join(',');
            this.storeTenantsToLocalStorage(tenant);
        }
        else {
            tenant = tenants[0];
        }
        tenant = tenants.length > 0 ? tenant : null;
        if (!multiTenant) {
            this.parameterService.setValue('tenant', tenant);
        }
        this.selectedTenant = {
            multiTenant: multiTenant,
            tenant: tenant,
            tenantList: tenants,
            allTenants: this.tenantList
        };
        this.tenantState.next(this.selectedTenant);
    }
    /**
     * Get the observable tenantState - notifying any tenant selection change.
     */
    getTenantState() {
        return this.tenantState;
    }
    /**
     * Get the currently selected Tenant - should only be used for simple current status checks.
     * Note: This function  is synchronous. While the state of tenant is asynchronous. This function is meant
     * for simple checks of current status only. Therefore, please use the {@link getTenantState()} function
     * for getting the selected tenant which considers the asynchronicity.
     */
    getSelectedTenant() {
        return this.selectedTenant;
    }
    storeTenantsToLocalStorage(tenants) {
        const selectedApp = this.applicationService.getSelectedApplication();
        const id = selectedApp.area + '|' + selectedApp.name;
        localStorage.setItem(id + '_tenants', tenants);
    }
    loadTenantsFromLocalStorage() {
        const selectedApp = this.applicationService.getSelectedApplication();
        const id = selectedApp.area + '|' + selectedApp.name;
        const locStor = localStorage.getItem(id + '_tenants');
        let list = locStor !== null && locStor !== '' ? locStor.split(',') : undefined;
        const that = this;
        // if the tenant(s) from local storage are available for current application -> select
        if (list) {
            list = list.filter(function (element) {
                return that.tenantList.indexOf(element) > -1;
            });
        }
        return list;
    }
};
TenantService.ɵfac = function TenantService_Factory(t) { return new (t || TenantService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(ParameterService), ɵngcc0.ɵɵinject(ApplicationService), ɵngcc0.ɵɵinject(ɵngcc4.TranslateService)); };
TenantService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: TenantService, factory: TenantService.ɵfac });
TenantService.ctorParameters = () => [
    { type: HttpClient },
    { type: ParameterService },
    { type: ApplicationService },
    { type: TranslateService }
];
TenantService = __decorate([ __metadata("design:paramtypes", [HttpClient,
        ParameterService,
        ApplicationService,
        TranslateService])
], TenantService);

let VersionsService = class VersionsService {
    constructor(http) {
        this.http = http;
        this.versionsPath = '/rest/energy/portal/versions';
    }
    /**
    * Get the infrastructure component versions.
    */
    getInfrastructureVersions() {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/vnd.energy.portal-v1.0+json; charset=UTF-8');
        return this.http
            .get(this.versionsPath, { headers: headers });
    }
    getApplicationVersion() {
        return this.appVersion;
    }
    setApplicationVersion(version) {
        this.appVersion = version;
    }
    setComponentKey(key) {
        this.componentKey = key;
    }
    getComponentKey() {
        return this.componentKey;
    }
};
VersionsService.ɵfac = function VersionsService_Factory(t) { return new (t || VersionsService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient)); };
VersionsService.ctorParameters = () => [
    { type: HttpClient }
];
VersionsService.ɵprov = ɵɵdefineInjectable({ factory: function VersionsService_Factory() { return new VersionsService(ɵɵinject(HttpClient)); }, token: VersionsService, providedIn: "root" });
VersionsService = __decorate([ __metadata("design:paramtypes", [HttpClient])
], VersionsService);

let HeaderComponent = class HeaderComponent {
    constructor(authService, tenantService, applicationService, parameterService, helpService, languageService, themeService, translate, versionsService, router, messageService) {
        this.authService = authService;
        this.tenantService = tenantService;
        this.applicationService = applicationService;
        this.parameterService = parameterService;
        this.helpService = helpService;
        this.languageService = languageService;
        this.themeService = themeService;
        this.translate = translate;
        this.versionsService = versionsService;
        this.router = router;
        this.messageService = messageService;
        this.menuItems = [];
        this.userMenuItems = [];
        this.selectedApplication = this.applicationService.selected;
        this.baseProperties = { logoUrl: '' };
        this.selectedTenant = null;
        this.loginInfo = { username: null };
        this.apps = [];
        this.displayTenant = null;
        this.applicationVersion = null;
        this.applicationVersionShort = null;
    }
    ngOnInit() {
        this.bHideHelp =
            typeof this.hideHelp === 'boolean'
                ? this.hideHelp
                : this.hideHelp === 'true';
        this.bHideLogin =
            typeof this.hideLogin === 'boolean'
                ? this.hideLogin
                : this.hideLogin === 'true';
        this.bHideApplications =
            typeof this.hideApplications === 'boolean'
                ? this.hideApplications
                : this.hideApplications === 'true';
        this.bOnlyDefaultLanguages =
            typeof this.onlyDefaultLanguages === 'boolean'
                ? this.onlyDefaultLanguages
                : this.onlyDefaultLanguages === 'true';
        this.bHideThemes =
            typeof this.hideThemes === 'boolean'
                ? this.hideThemes
                : this.hideThemes === 'true';
        this.setLanguages();
        this.setLogo();
        if (!this.bHideApplications) {
            this.setApplications();
        }
        if (!this.bHideLogin) {
            this.authenticate();
        }
        this.translate.onLangChange.subscribe(() => {
            this.buildUserMenuModel();
            this.refreshTranslations(this.languageService.getLanguage());
        });
    }
    authenticate() {
        if (!this.bHideLogin) {
            this.authInfoSubscription = this.authService.getAuthInfo().subscribe((authInfo) => {
                this.loginInfo = authInfo;
                if (authInfo.loggedin === true) {
                    this.buildUserMenuModel();
                }
            }, (err) => {
                if (err.error instanceof Error) {
                    // A client-side or network error occurred. Handle it accordingly.
                    console.log('An error occurred:', err.error.message);
                }
                else {
                    // The backend returned an unsuccessful response code.
                    // The response body may contain clues as to what went wrong,
                    console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
                }
            });
            this.tenantInfoSubscription = this.tenantService
                .getTenantState()
                .subscribe((tenantState) => {
                if (tenantState) {
                    this.selectedTenant = tenantState.tenant;
                    if (tenantState.multiTenant) {
                        if (tenantState.tenantList.length > 1) {
                            this.displayTenant =
                                tenantState.tenantList.length +
                                    '/' +
                                    tenantState.allTenants.length +
                                    ' ' +
                                    this.translate.instant('TENANTS');
                        }
                        else {
                            this.displayTenant = tenantState.tenant;
                        }
                        this.tenantMultiLineTooltip =
                            tenantState.tenant && tenantState.tenantList.length > 1
                                ? tenantState.tenant.replace(/,/g, ' \n ')
                                : false;
                    }
                    else {
                        this.displayTenant = tenantState.tenant;
                        this.tenantMultiLineTooltip = false;
                    }
                }
            });
        }
        else {
            if (this.authInfoSubscription) {
                this.authInfoSubscription.unsubscribe();
            }
            if (this.tenantInfoSubscription) {
                this.tenantInfoSubscription.unsubscribe();
            }
        }
    }
    /**
     * Retrieve selectable languages and set them in the language service and the user menu.
     * The backend call has to be done here, as applications can disable the call in HTML. The language-service
     * doesn't have this information on start up.
     */
    setLanguages() {
        if (this.bOnlyDefaultLanguages === true) {
            this.languageService.initLanguage(true);
            this.buildUserMenuModel();
            return;
        }
        // get the supported languages
        this.applicationService.getLanguageProperties().subscribe((data) => {
            if (data) {
                const selectableLanguagesArr = data.split(',');
                const selectableLanguages = [];
                for (let i = 0; i < selectableLanguagesArr.length; i++) {
                    const langProperties = selectableLanguagesArr[i].split('-');
                    const langTag = langProperties[0];
                    const nativeLangName = langProperties[1];
                    const tag = langTag.split('_');
                    // set the language in the user menu like this: Deutsch (CH)
                    const regionCode = ' (' + tag[1] + ')';
                    selectableLanguages.push({
                        name: nativeLangName + regionCode,
                        tag: langTag
                    });
                }
                this.languageService.setSelectableLanguages(selectableLanguages);
                // get start language and save in local storage and parameter service
                this.languageService.initLanguage(true);
                this.buildUserMenuModel();
            }
        }, (err) => {
            // languages could not be retrieved from backend
            // persist the currently available default languages and currently set language
            this.languageService.initLanguage(true);
        });
    }
    /**
     * Retrieve and set the logo in the logo area.
     */
    setLogo() {
        // set default KISTERS Logo
        var logoUrl = 'assets/img/kisterslogo_2014.svg';
        if (document.getElementById('logoArea')) {
            document.getElementById('logoArea').setAttribute('src', logoUrl);
        }
        // request application properties from backend and check for a custom logo
        this.applicationService.getApplicationBaseProperties().subscribe((response) => {
            if (response && 'logoUrl' in response) {
                this.baseProperties = response;
                logoUrl = this.baseProperties.logoUrl;
            }
            if (isDefined(logoUrl) &&
                logoUrl !== '' &&
                document.getElementById('logoArea')) {
                // additional check for faulty path from portal backend (angularJS default)
                if (logoUrl.includes('libs/frame-module/assets/img/kisterslogo_2014.svg')) {
                    // keep own default
                    return;
                }
                document.getElementById('logoArea').setAttribute('src', logoUrl);
            }
        }, (error) => {
            if (document.getElementById('logoArea')) {
                document.getElementById('logoArea').setAttribute('src', logoUrl);
            }
        });
    }
    /**
     * Check whether or not the list of applications is available and set if necessary.
     */
    checkApplications() {
        if (!this.apps || this.apps.length < 1) {
            this.setApplications();
        }
    }
    /**
     * Retrieve and set the applications.
     */
    setApplications() {
        const tmpList = [];
        // load apps and set selected
        this.applicationService.getApplicationList().subscribe((apps) => {
            for (let i = 0; i < apps.length; i++) {
                tmpList.push(apps[i]);
            }
            this.apps = tmpList;
            this.apps = this.refreshTranslations(this.languageService.getLanguage());
            this.selectedApplication = this.applicationService.selected;
            this.buildAppMenuModel();
        }, (err) => {
            if (err.error instanceof Error) {
                // A client-side or network error occurred. Handle it accordingly.
                console.log('An error occurred:', err.error.message);
            }
            else {
                // The backend returned an unsuccessful response code.
                // The response body may contain clues as to what went wrong,
                console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
            }
            // set a default on error
            this.selectedApplication = new ApplicationDesc('KISTERS', 'Application', '', window.location.host, false, false);
        });
    }
    buildAppMenuModel() {
        const nbsp = String.fromCharCode(160);
        this.menuItems = [];
        this.apps.forEach((app) => {
            const icon = app.icon
                ? app.icon.indexOf('fa') >= 0
                    ? 'fa ' + app.icon
                    : app.icon
                : '';
            const area = app.area.replace(/ /g, nbsp);
            const name = app.name.replace(/ /g, nbsp);
            let appurl;
            let command;
            if (!app.requireTenant) {
                let composedURL = this.parameterService.composeUrl(app);
                if (!composedURL.startsWith('http://') &&
                    !composedURL.startsWith('https://')) {
                    // make sure a protocol is set in order to prevent Angular sanitation problems
                    composedURL = window.location.protocol + '//' + composedURL;
                }
                appurl = composedURL;
            }
            else {
                const that = this;
                command = function (event) {
                    const i = parseInt(event.item.id, 10);
                    const aapp = that.apps[i];
                    that.selectAppWithTenant(aapp);
                };
            }
            this.menuItems.push({
                id: this.menuItems.length.toString(),
                label: area + nbsp + name,
                command: command,
                icon: icon,
                url: appurl
            });
        });
    }
    openTenantSelection() {
        this.tenantService.openTenantSelection();
    }
    buildUserMenuModel() {
        const that = this;
        this.userMenuItems = [];
        // log-in / log-out / user profile
        if (!this.bHideLogin) {
            const userSubItems = [];
            if (this.loginInfo.username == null) {
                userSubItems.push({
                    label: this.translate.instant('LOG_IN'),
                    icon: 'fa fa-sign-in',
                    command: function (e) {
                        that.login();
                    }
                });
            }
            else if (this.loginInfo.username !== null ||
                this.loginInfo.username === undefined ||
                this.loginInfo.username === '') {
                userSubItems.push({
                    label: this.translate.instant('LOG_OUT'),
                    icon: 'fa fa-sign-in',
                    command: function (e) {
                        that.logoff();
                    }
                });
                userSubItems.push({
                    label: this.translate.instant('SELECT_TENANT'),
                    icon: 'fa fa-users',
                    command: function (e) {
                        that.openTenantSelection();
                    }
                });
                userSubItems.push({
                    label: this.translate.instant('USER_PROFILE'),
                    icon: 'fa fa-user-circle-o',
                    command: function (e) {
                        that.callUserProfile();
                    }
                });
            }
            this.userMenuItems.push({
                label: this.translate.instant('SIGN_IN'),
                items: userSubItems
            });
        }
        // language selection
        const languageSubItems = [];
        this.getSelectableLanguages().forEach(function (lang) {
            languageSubItems.push({
                label: lang.name,
                icon: 'fa fa-language',
                tag: lang.tag,
                command: function (e) {
                    that.setLanguage(e.item.tag);
                }
            });
        });
        this.userMenuItems.push({
            label: this.translate.instant('LANGUAGE'),
            items: languageSubItems
        });
        // theme selection
        if (!this.bHideThemes) {
            const themeSubItems = [];
            this.getThemes().forEach(function (aTheme) {
                themeSubItems.push({
                    label: aTheme.name,
                    icon: 'fa fa-tint',
                    theme: aTheme,
                    command: function (e) {
                        that.setTheme(e.item.theme);
                    }
                });
            });
            this.userMenuItems.push({
                label: this.translate.instant('THEMES'),
                items: themeSubItems
            });
        }
        // About + licenses + versions
        const aboutSubItems = [];
        aboutSubItems.push({
            label: this.translate.instant('LICENSES'),
            icon: 'fa fa-id-card',
            // tag: licensesTag, ?? TODO
            command: function (event) {
                that.callLicensesViewer();
            }
        });
        aboutSubItems.push({
            label: this.translate.instant('VERSIONS'),
            icon: 'fa fa-code-fork',
            // tag: versionsTag, ?? TODO
            command: function (event) {
                that.callVersionsDialog();
            }
        });
        this.userMenuItems.push({
            label: this.translate.instant('ABOUT'),
            items: aboutSubItems
        });
    }
    composeUrl(application) {
        return this.parameterService.composeUrl(application);
    }
    selectAppWithTenant(application) {
        this.applicationService.selectAppWithTenant(application);
    }
    getSelectableLanguages() {
        return this.languageService.getSelectableLanguages();
    }
    setLanguage(pLanguage) {
        this.languageService.setLanguage(pLanguage);
    }
    getThemes() {
        return this.themeService.getThemes();
    }
    setTheme(pTheme) {
        this.themeService.setTheme(pTheme);
    }
    // update application area and name in the currently selected language
    refreshTranslations(lang) {
        if (lang) {
            return this.applicationService.updateTranslatedAppNamesAndAreas(lang);
        }
    }
    callHelp(context) {
        this.helpService.call(context);
    }
    login() {
        this.authService.login();
    }
    logoff() {
        this.authService.logoutAll(this.apps, 0);
    }
    callUserProfile() {
        this.authService.getUserProfilePath().subscribe((response) => {
            window.location.href = response;
        });
    }
    callLicensesViewer() {
        let path = '';
        const licensePath = window.location.href.replace(this.router.url, '/licenses');
        this.router.navigate([]).then((result) => {
            window.open(licensePath);
        });
    }
    /**
     * Display the application version in a toaster message.
     */
    callVersionsDialog() {
        let appVersion = this.versionsService.getApplicationVersion();
        let componentKey = this.versionsService.getComponentKey();
        if (appVersion && !componentKey) {
            this.applicationVersion = appVersion;
            this.messageService.add({
                severity: 'info',
                summary: this.translate.instant('APP_VERSION_TITLE'),
                detail: this.applicationVersion
            });
        }
        else if (componentKey) {
            this.versionsService.getInfrastructureVersions().subscribe((response) => {
                for (var key in response) {
                    if (response.hasOwnProperty(key)) {
                        if (key === componentKey) {
                            this.applicationVersion = response[key].version;
                            this.applicationVersionShort = this.applicationVersion.substring(0, this.applicationVersion.indexOf('-'));
                            this.messageService.add({
                                severity: 'info',
                                summary: this.translate.instant('APP_VERSION_TITLE'),
                                detail: this.applicationVersion
                            });
                        }
                    }
                }
            }, (err) => {
                if (err.status !== 200) {
                    this.messageService.add({
                        severity: 'error',
                        summary: this.translate.instant('APP_VERSION_TITLE'),
                        detail: this.translate.instant('VERSION_NOT_FOUND')
                    });
                }
            });
        }
    }
};
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(ɵngcc0.ɵɵdirectiveInject(AuthService), ɵngcc0.ɵɵdirectiveInject(TenantService), ɵngcc0.ɵɵdirectiveInject(ApplicationService), ɵngcc0.ɵɵdirectiveInject(ParameterService), ɵngcc0.ɵɵdirectiveInject(HelpService), ɵngcc0.ɵɵdirectiveInject(LanguageService), ɵngcc0.ɵɵdirectiveInject(ThemeService), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.TranslateService), ɵngcc0.ɵɵdirectiveInject(VersionsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.MessageService)); };
HeaderComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["ki-header"]], inputs: { hideHelp: "hideHelp", hideLogin: "hideLogin", hideApplications: "hideApplications", onlyDefaultLanguages: "onlyDefaultLanguages", hideThemes: "hideThemes" }, decls: 28, vars: 18, consts: [["popup", "true", 3, "appendTo", "model"], ["appMenu", ""], ["userMenu", ""], ["id", "ki-logo-area"], ["id", "ki-logo", "title", "Startseite"], ["id", "logoArea", "src", "", "alt", "LOGO", 2, "height", "31px", "width", "184px"], ["id", "app-div", 1, "ui-cursor", 3, "hidden", "click"], ["appDiv", ""], [1, "ki-bold"], [2, "margin-left", "0.5em"], [1, "ki-applist-icon-color", "ki-margin5", "fa", "fa-chevron-down"], ["id", "user-div"], ["userDiv", ""], ["class", "ui-cursor", 4, "ngIf"], [1, "ki-margin5", "ui-cursor", 3, "ngSwitch", "click"], ["aria-hidden", "true", 1, "fa", "fa-user"], ["class", "user-menu-label", 4, "ngSwitchCase"], ["aria-hidden", "true", 1, "ki-margin5", "fa", "fa-chevron-down"], ["class", "fa fa-question-circle ui-cursor", "style", "margin-left: 10px", "aria-hidden", "true", "ki-animate", "", 3, "click", 4, "ngIf"], [1, "ui-cursor"], ["tooltipPosition", "bottom", 3, "pTooltip", "escape", "click"], [1, "user-menu-label"], ["aria-hidden", "true", "ki-animate", "", 1, "fa", "fa-question-circle", "ui-cursor", 2, "margin-left", "10px", 3, "click"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        const _r12 = ɵngcc0.ɵɵgetCurrentView();
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelement(1, "ki-content");
        ɵngcc0.ɵɵelement(2, "ki-language-selection");
        ɵngcc0.ɵɵelement(3, "p-menu", 0, 1);
        ɵngcc0.ɵɵelement(5, "p-menu", 0, 2);
        ɵngcc0.ɵɵelementStart(7, "div", 3);
        ɵngcc0.ɵɵelementStart(8, "div", 4);
        ɵngcc0.ɵɵelement(9, "img", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 6, 7);
        ɵngcc0.ɵɵlistener("click", function HeaderComponent_Template_div_click_10_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const _r0 = ɵngcc0.ɵɵreference(4); ctx.checkApplications(); return _r0.toggle($event); });
        ɵngcc0.ɵɵelementStart(12, "span", 8);
        ɵngcc0.ɵɵtext(13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "span", 9);
        ɵngcc0.ɵɵtext(15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(16, "i", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(17, "div", 11, 12);
        ɵngcc0.ɵɵtemplate(19, HeaderComponent_span_19_Template, 3, 3, "span", 13);
        ɵngcc0.ɵɵelementStart(20, "span", 14);
        ɵngcc0.ɵɵlistener("click", function HeaderComponent_Template_span_click_20_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const _r1 = ɵngcc0.ɵɵreference(6); return _r1.toggle($event); });
        ɵngcc0.ɵɵelement(21, "i", 15);
        ɵngcc0.ɵɵtemplate(22, HeaderComponent_span_22_Template, 3, 3, "span", 16);
        ɵngcc0.ɵɵtemplate(23, HeaderComponent_span_23_Template, 3, 3, "span", 16);
        ɵngcc0.ɵɵelement(24, "i", 17);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(25, HeaderComponent_i_25_Template, 1, 0, "i", 18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(26, "ki-tenant");
        ɵngcc0.ɵɵelement(27, "p-toast");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(11);
        const _r3 = ɵngcc0.ɵɵreference(18);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(16, _c0));
        ɵngcc0.ɵɵproperty("appendTo", _r2)("model", ctx.menuItems);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(17, _c1));
        ɵngcc0.ɵɵproperty("appendTo", _r3)("model", ctx.userMenuItems);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("hidden", ctx.bHideApplications);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.selectedApplication.area);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.selectedApplication.name);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayTenant !== null && !ctx.bHideLogin);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.bHideLogin);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngSwitchCase", false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.bHideHelp);
    } }, directives: function () { return [ContentComponent,
        LanguageSelectionComponent, ɵngcc6.Menu, ɵngcc2.NgIf, ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase, TenantComponent, ɵngcc7.Toast, ɵngcc8.Tooltip]; }, pipes: function () { return [ɵngcc4.TranslatePipe]; }, styles: [".ki-menulist[_ngcontent-%COMP%]{position:absolute;top:100%;left:-8.5714286em;z-index:1000;float:left;min-width:17.8571429em;text-align:left}.ki-menulist-item[_ngcontent-%COMP%]{cursor:pointer;cursor:hand;padding:.3571429em}.ki-menulist-subItem[_ngcontent-%COMP%]{padding-left:1.78571429em}.ki-applist[_ngcontent-%COMP%]{display:table;position:absolute;z-index:1000;left:11.07142858em;margin-top:.14285715em;padding-top:.357142858em;padding-bottom:.357142858em}.ki-applist-item[_ngcontent-%COMP%]{display:table-row;text-decoration:none}.ki-applist-item[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{display:table-cell;padding:.357142858em}.ki-frame-user-bar[_ngcontent-%COMP%]{position:absolute;right:2.14285715em;bottom:0}.ki-frame-user-bar[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{font-size:1.28571429em;margin-right:.21428571429em}.ki-frame-user-bar[_ngcontent-%COMP%] > span[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{font-size:1.28571429em}.ki-margin5[_ngcontent-%COMP%]{margin-left:.357142858em}#ki-logo-area[_ngcontent-%COMP%]{position:fixed;top:0;left:0;height:50px;width:100%;min-width:0;z-index:2}#ki-logo[_ngcontent-%COMP%]{position:absolute;display:block;margin-right:15px;left:15px;background-repeat:no-repeat;width:184px;height:31px;border:none;outline:0;bottom:7px}#app-div[_ngcontent-%COMP%]{position:absolute;left:230px;bottom:3px;right:unset;font-family:\"Open Sans\";font-weight:400;line-height:normal;font-size:16px}#user-div[_ngcontent-%COMP%]{position:absolute;right:30px;bottom:3px;font-family:\"Open Sans\";font-weight:400;line-height:normal;font-size:16px}[_nghost-%COMP%]     .ui-menu{width:25em;font-size:14px;padding:0}[_nghost-%COMP%]     .ui-menu .ui-submenu-header{padding:.56em 1em}[_nghost-%COMP%]     .ui-menu .ui-menuitem-link{padding:.56em 1em}[_nghost-%COMP%]     .ui-menu .ui-menuitem-icon{width:1.5em}[_nghost-%COMP%]     .ui-menu.ui-menu-dynamic{top:47px!important;display:block!important}.ui-cursor[_ngcontent-%COMP%]{cursor:pointer}.user-menu-label[_ngcontent-%COMP%]{margin-left:.25em;margin-right:.25em}"] });
HeaderComponent.ctorParameters = () => [
    { type: AuthService },
    { type: TenantService },
    { type: ApplicationService },
    { type: ParameterService },
    { type: HelpService },
    { type: LanguageService },
    { type: ThemeService },
    { type: TranslateService },
    { type: VersionsService },
    { type: Router },
    { type: MessageService }
];
__decorate([
    Input(),
    __metadata("design:type", Object)
], HeaderComponent.prototype, "hideHelp", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], HeaderComponent.prototype, "hideLogin", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], HeaderComponent.prototype, "hideApplications", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], HeaderComponent.prototype, "onlyDefaultLanguages", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], HeaderComponent.prototype, "hideThemes", void 0);
HeaderComponent = __decorate([ __metadata("design:paramtypes", [AuthService,
        TenantService,
        ApplicationService,
        ParameterService,
        HelpService,
        LanguageService,
        ThemeService,
        TranslateService,
        VersionsService,
        Router,
        MessageService])
], HeaderComponent);

let LanguageSelectionComponent = class LanguageSelectionComponent {
    constructor(languageService) {
        this.display = false;
        this.options = [];
        this.languageService = languageService;
        languageService.displaySelectionDialog
            .subscribe(languageOptions => this.openDialog(languageOptions));
    }
    openDialog(languageOptions) {
        this.options = languageOptions.map(item => ({ label: item.name, value: item.tag }));
        this.display = true;
    }
    save() {
        this.languageService.setLanguage(this.selected);
        this.display = false;
    }
    ngOnInit() {
    }
};
LanguageSelectionComponent.ɵfac = function LanguageSelectionComponent_Factory(t) { return new (t || LanguageSelectionComponent)(ɵngcc0.ɵɵdirectiveInject(LanguageService)); };
LanguageSelectionComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LanguageSelectionComponent, selectors: [["ki-language-selection"]], decls: 6, vars: 5, consts: [["header", "Select your Language", 3, "closable", "modal", "visible", "visibleChange"], [3, "options", "ngModel", "ngModelChange"], [2, "margin-top", "1.429em"], ["pButton", "", "type", "button", "label", "OK", 2, "float", "right", 3, "click"]], template: function LanguageSelectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-dialog", 0);
        ɵngcc0.ɵɵlistener("visibleChange", function LanguageSelectionComponent_Template_p_dialog_visibleChange_0_listener($event) { return ctx.display = $event; });
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "div");
        ɵngcc0.ɵɵelementStart(3, "p-listbox", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function LanguageSelectionComponent_Template_p_listbox_ngModelChange_3_listener($event) { return ctx.selected = $event; });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵelementStart(5, "button", 3);
        ɵngcc0.ɵɵlistener("click", function LanguageSelectionComponent_Template_button_click_5_listener() { return ctx.save(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("closable", false)("modal", true)("visible", ctx.display);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("options", ctx.options)("ngModel", ctx.selected);
    } }, directives: [ɵngcc9.Dialog, ɵngcc10.Listbox, ɵngcc11.NgControlStatus, ɵngcc11.NgModel, ɵngcc12.ButtonDirective], styles: [""] });
LanguageSelectionComponent.ctorParameters = () => [
    { type: LanguageService }
];
LanguageSelectionComponent = __decorate([ __metadata("design:paramtypes", [LanguageService])
], LanguageSelectionComponent);

let SidemenuComponent = class SidemenuComponent {
    constructor(aSidemenusService, aVersionsService) {
        this.version = 'none set';
        this.sidemenuService = aSidemenusService;
        this.versionsService = aVersionsService;
    }
    ngOnInit() {
        this.sidemenuService.setSideMenuReduced(typeof this.initiallyReduced === 'boolean'
            ? this.initiallyReduced
            : this.initiallyReduced === 'true');
        this.bHideVersion =
            typeof this.hideVersion === 'boolean'
                ? this.hideVersion
                : this.hideVersion === 'true';
        this.useInfraVersion =
            typeof this.useInfraVersion === 'boolean'
                ? this.useInfraVersion
                : this.useInfraVersion === 'true';
        if (this.version !== 'none set') {
            this.versionsService.setApplicationVersion(this.version);
            this.versionShort = this.version;
        }
        if (this.useInfraVersion && this.infraComponentKey) {
            this.versionsService.setComponentKey(this.infraComponentKey);
        }
        if (this.useInfraVersion) {
            this.getVersion();
        }
    }
    ngOnChanges(changeEvent) {
        if (changeEvent.version && changeEvent.version !== this.version) {
            this.versionsService.setApplicationVersion(this.version);
            this.versionShort = this.version;
        }
    }
    toggle() {
        this.sidemenuService.setSideMenuReduced(!this.sidemenuService.isReduced);
    }
    getTitle() {
        return this.sidemenuService.isReduced ? 'Expand' : 'Reduce';
    }
    getVersion() {
        this.versionsService.getInfrastructureVersions().subscribe((response) => {
            const infrastructureVersionKey = 'energy-infrastructure';
            for (const key in response) {
                if (response.hasOwnProperty(key)) {
                    if (key === infrastructureVersionKey) {
                        this.version = response[key].version;
                        this.versionShort = this.version.substring(0, this.version.indexOf('-'));
                    }
                }
            }
        }, (err) => {
            if (err.status !== 200) {
                this.version = undefined;
                this.versionShort = '?';
            }
        });
    }
};
SidemenuComponent.ɵfac = function SidemenuComponent_Factory(t) { return new (t || SidemenuComponent)(ɵngcc0.ɵɵdirectiveInject(SidemenuService), ɵngcc0.ɵɵdirectiveInject(VersionsService)); };
SidemenuComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SidemenuComponent, selectors: [["ki-sidemenu"]], inputs: { version: "version", useInfraVersion: "useInfraVersion", hideVersion: "hideVersion", initiallyReduced: "initiallyReduced", infraComponentKey: "infraComponentKey" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c3, decls: 9, vars: 3, consts: [[1, "ki-side-menu", "ki-sidemenu-border", 3, "ngClass"], [2, "background-color", "#ffffff", "height", "2.5em"], [1, "ki-menu-toggle", 3, "title", "click"], [1, "fa", "fa-bars"], [1, "ki-menu-list"], [3, "ngSwitch", 4, "ngIf"], [3, "ngSwitch"], [4, "ngSwitchCase"], ["tabindex", "-1", "tooltipPosition", "top", 1, "version", 3, "pTooltip", "escape"], [1, "version-icon"], [1, "fa", "fa-info-circle", 3, "title"]], template: function SidemenuComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c2);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "span", 2);
        ɵngcc0.ɵɵlistener("click", function SidemenuComponent_Template_span_click_2_listener() { return ctx.toggle(); });
        ɵngcc0.ɵɵelement(3, "i", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵelementStart(5, "div");
        ɵngcc0.ɵɵprojection(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div");
        ɵngcc0.ɵɵtemplate(8, SidemenuComponent_div_8_Template, 3, 3, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.sidemenuService.isReduced ? "ki-side-menu-reduced" : "ki-side-menu-expand");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("title", ctx.getTitle());
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.bHideVersion);
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase, ɵngcc8.Tooltip], pipes: [ɵngcc4.TranslatePipe], styles: [".ki-side-menu[_ngcontent-%COMP%]{position:fixed;z-index:1;box-sizing:border-box;border-right:2px solid #d3d3d3;float:left;top:50px;bottom:0;-webkit-padding-start:0;overflow-x:hidden;overflow-y:hidden}.version[_ngcontent-%COMP%]{font-size:.8em;padding-left:7px;position:absolute;cursor:default;z-index:5;background-color:#fff;bottom:0;padding-bottom:.3571428571em;width:90%}.version-icon[_ngcontent-%COMP%]{bottom:5px;position:absolute;padding-left:13px;cursor:default;z-index:5}.ki-side-menu-reduced[_ngcontent-%COMP%]{width:2.79em}.ki-side-menu-expand[_ngcontent-%COMP%]{width:18.93em}.ki-menu-toggle[_ngcontent-%COMP%]{float:right;padding-top:10px;padding-right:10px;padding-left:10px;cursor:pointer;cursor:hand;position:sticky;position:-webkit-sticky;top:0;z-index:5}.ki-menu-list[_ngcontent-%COMP%]{margin-top:0;padding-left:0;left:-120px;list-style:none;overflow-y:auto;overflow-x:hidden;max-height:92%}"] });
SidemenuComponent.ctorParameters = () => [
    { type: SidemenuService },
    { type: VersionsService }
];
__decorate([
    Input(),
    __metadata("design:type", Object)
], SidemenuComponent.prototype, "hideVersion", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], SidemenuComponent.prototype, "initiallyReduced", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], SidemenuComponent.prototype, "version", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], SidemenuComponent.prototype, "useInfraVersion", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], SidemenuComponent.prototype, "infraComponentKey", void 0);
SidemenuComponent = __decorate([ __metadata("design:paramtypes", [SidemenuService,
        VersionsService])
], SidemenuComponent);

var SidemenuItemComponent_1;
class SideMenuItemStatus {
}
let SidemenuItemComponent = SidemenuItemComponent_1 = class SidemenuItemComponent {
    constructor(aSidemenuService, aRouter, parent) {
        this.label = 'no item label set';
        this.name = 'not set';
        this.mainIconClasses = '';
        this.showSubmenu = false;
        this.isSelected = false;
        this.router = undefined;
        this.isSubItem = false;
        this.sideMenuReduced = false;
        this.isItemSelected = function (sideMenuItem, event) {
            if (!sideMenuItem || !sideMenuItem.link || !event || !event.url) {
                return false;
            }
            // make sure the format of the links is the same
            let currentUrl = event.url ? event.url : '';
            const paramIndex = event.url.indexOf('?');
            const fragmentIndex = event.url.indexOf('#');
            if (paramIndex > -1 && fragmentIndex > -1) {
                currentUrl = currentUrl.replace(currentUrl.slice(paramIndex, fragmentIndex), '');
            }
            else if (paramIndex > -1) {
                currentUrl = currentUrl.split('?')[0];
            }
            let link = '';
            if (Array.isArray(sideMenuItem.link)) {
                link = sideMenuItem.link ? sideMenuItem.link.join('/') : '';
            }
            else {
                link = sideMenuItem.link ? sideMenuItem.link : '';
            }
            if (link.startsWith('/') && !currentUrl.startsWith('/')) {
                currentUrl = '/' + currentUrl;
            }
            else if (!link.startsWith('/') && currentUrl.startsWith('/')) {
                currentUrl = currentUrl.substring(1);
            }
            if (sideMenuItem.fragment) {
                // if this item contains a fragment, include it for the comparison
                link += '#' + sideMenuItem.fragment;
            }
            if (link.length < currentUrl.length) {
                // if this item's link is shorter than the current route url, this item can not be the selected one
                return false;
            }
            if (currentUrl.indexOf(link) >= 0) {
                // if current route contains this item's link, it is the selected one
                return true;
            }
            // every other case, this item can not be the selected one
            return false;
        };
        /**
         * Assemble all needed classes to show either font-awesome or KISTERS icons on side-menu items.
         * Users of energy-frame-lib can give KISTERS (ki-) or font-awesome (fa-) icon classes.
         * This function automatically adds the needed 'ki' or 'fa' classes, if neccessary, and the 'ki-menu-icon' class.
         */
        this.updateMainIconClasses = function () {
            const icon = this.icon;
            if (!icon) {
                return;
            }
            let iconClasses = 'ki-menu-icon ';
            if (icon.indexOf('ki-') > -1 && icon.indexOf('ki ') < 0) {
                iconClasses = iconClasses + 'ki ' + icon;
            }
            else if (icon.indexOf('fa-') > -1 && icon.indexOf('fa ') < 0) {
                iconClasses = iconClasses + 'fa ' + icon;
            }
            else {
                iconClasses = iconClasses + icon;
            }
            this.mainIconClasses = iconClasses;
        };
        this.sidemenuService = aSidemenuService;
        this.router = aRouter;
        if (parent) {
            this.parentSideMenuItem = parent;
        }
        // check if this or a child element is selected on each router NavigationEnd
        aRouter.events.forEach((event) => {
            if (event instanceof NavigationEnd) {
                // check if this item is selected
                this.isSelected = this.isItemSelected(this, event);
                // alternatively check if a sub element is selected
                if (!this.isSelected && this.items.length > 0) {
                    const that = this;
                    this.items.forEach(function (subElement) {
                        if (that.isItemSelected(subElement, event)) {
                            // a sub element is selected, open sub menu and return
                            that.openSub();
                            return;
                        }
                    });
                }
            }
            // NavigationStart
            // NavigationCancel
            // NavigationError
            // RoutesRecognized
        });
        if (this.parentSideMenuItem) {
            // Check if this component has another sidemenu-item component as parent and set flag accordingly
            this.isSubItem = true;
        }
        // subscribe to be notified of recude / expand events to the side menu
        this.sidemenuService.reducedChangeSubject.subscribe((state) => {
            this.sideMenuReduced = state;
            this.updateMainIconClasses();
        });
    }
    ngOnInit() {
        if (!this.label) {
            this.label = this.name;
        }
        this.updateMainIconClasses();
    }
    ngAfterViewInit() {
        // workaround: subElements contains host as well, because type is the same -> filter to remove host
        this.items = this.subElements.filter((item) => item !== this);
    }
    openSub() {
        if (this.hasSubmenu && this.hasSubmenu === 'true') {
            this.showSubmenu = true;
        }
    }
    toggleSub() {
        this.showSubmenu = !this.showSubmenu;
    }
};
SidemenuItemComponent.ɵfac = function SidemenuItemComponent_Factory(t) { return new (t || SidemenuItemComponent)(ɵngcc0.ɵɵdirectiveInject(SidemenuService), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.Router), ɵngcc0.ɵɵdirectiveInject(SidemenuItemComponent, 12)); };
SidemenuItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: SidemenuItemComponent, selectors: [["ki-sidemenu-item"]], contentQueries: function SidemenuItemComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, SidemenuItemComponent_1, false);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.subElements = _t);
    } }, inputs: { label: "label", name: "name", icon: "icon", image: "image", link: "link", fragment: "fragment", params: "params", hasSubmenu: "hasSubmenu", statusIcon: "statusIcon" }, ngContentSelectors: _c4, decls: 8, vars: 10, consts: [["tabindex", "1", 1, "ki-menu-item", 3, "ngClass"], ["class", "ki-menu-item-selected-marker", 4, "ngIf"], ["routerLinkActive", "active", 1, "ui-g", 2, "text-decoration", "none", 3, "routerLink", "fragment", "queryParams", "name", "click"], ["class", "ui-g-1 no-padding", 3, "ngClass", 4, "ngIf"], ["class", "ui-g-10 no-padding ki-menu-item-label", 4, "ngIf"], ["class", "item-chevron", 3, "ngClass", "click", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], [1, "ki-menu-item-selected-marker"], [1, "ui-g-1", "no-padding", 3, "ngClass"], ["tabindex", "-1", 3, "ngClass"], [3, "class", 4, "ngIf"], [1, "ui-g-10", "no-padding", "ki-menu-item-label"], [3, "class", "ngClass", "title", 4, "ngIf"], [3, "ngClass", "title"], [1, "item-chevron", 3, "ngClass", "click"], [3, "ngClass"]], template: function SidemenuItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, SidemenuItemComponent_span_1_Template, 1, 0, "span", 1);
        ɵngcc0.ɵɵelementStart(2, "a", 2);
        ɵngcc0.ɵɵlistener("click", function SidemenuItemComponent_Template_a_click_2_listener() { return ctx.openSub(); });
        ɵngcc0.ɵɵtemplate(3, SidemenuItemComponent_span_3_Template, 3, 3, "span", 3);
        ɵngcc0.ɵɵtemplate(4, SidemenuItemComponent_span_4_Template, 3, 2, "span", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "span");
        ɵngcc0.ɵɵtemplate(6, SidemenuItemComponent_i_6_Template, 1, 1, "i", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, SidemenuItemComponent_div_7_Template, 2, 1, "div", 6);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ctx.isSelected ? "ki-menu-item-selected" : "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isSelected);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("name", ctx.name);
        ɵngcc0.ɵɵproperty("routerLink", ctx.link)("fragment", ctx.fragment)("queryParams", ctx.params);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.icon !== undefined || ctx.image !== undefined);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.sideMenuReduced);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.sideMenuReduced && ctx.hasSubmenu === "true");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showSubmenu);
    } }, directives: [ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc1.RouterLinkWithHref, ɵngcc1.RouterLinkActive], styles: [".ki-menu-icon[_ngcontent-%COMP%]{margin:2px 10px 2px 0;cursor:pointer}.ki-menu-icon[_ngcontent-%COMP%]:disabled{cursor:default}.ki-menu-sub-list[_ngcontent-%COMP%]{padding-left:20px}.ki-sub-menu-toggle[_ngcontent-%COMP%]{float:right;top:6px;right:4px;cursor:pointer;cursor:hand;position:absolute;padding:5px 10px}.ki-menu-item[_ngcontent-%COMP%]{position:relative;padding-left:15px;padding-top:8px;padding-bottom:8px;z-index:2}.ki-menu-item-selected-marker[_ngcontent-%COMP%]{position:absolute;top:0;bottom:0;margin-right:5px;margin-left:-15px;padding-left:5px}.ki-menu-sub-list[_ngcontent-%COMP%]   .ki-menu-item-selected-marker[_ngcontent-%COMP%]{padding-left:25px;margin-left:-35px}.ki-menu-item-label[_ngcontent-%COMP%]{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;margin-left:5px;width:12.86em;display:inline-block;vertical-align:bottom}.ki-menu-item[_ngcontent-%COMP%]:not(.ki-menu-item-selected)   a[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:hover, .ki-menu-item[_ngcontent-%COMP%]:not(.ki-menu-item-selected) > a[_ngcontent-%COMP%]:focus{text-decoration:none}.no-padding[_ngcontent-%COMP%]{padding:0;padding:unset}.item-chevron[_ngcontent-%COMP%]{margin-top:.1em}.item-status-icon[_ngcontent-%COMP%]{margin-top:.3em;margin-right:.8em}.sub-item-status-icon[_ngcontent-%COMP%]{margin-top:.3em;margin-right:.1em}.reduced-menu-status-icon[_ngcontent-%COMP%]{text-align:unset;margin-left:.6em;margin-top:.6em}  .fa-stack{height:unset;line-height:unset}"] });
SidemenuItemComponent.ctorParameters = () => [
    { type: SidemenuService },
    { type: Router },
    { type: SidemenuItemComponent, decorators: [{ type: Optional }, { type: SkipSelf }] }
];
__decorate([
    Input(),
    __metadata("design:type", Object)
], SidemenuItemComponent.prototype, "label", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], SidemenuItemComponent.prototype, "icon", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], SidemenuItemComponent.prototype, "image", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], SidemenuItemComponent.prototype, "link", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], SidemenuItemComponent.prototype, "fragment", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], SidemenuItemComponent.prototype, "params", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], SidemenuItemComponent.prototype, "name", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], SidemenuItemComponent.prototype, "hasSubmenu", void 0);
__decorate([
    Input(),
    __metadata("design:type", SideMenuItemStatus)
], SidemenuItemComponent.prototype, "statusIcon", void 0);
__decorate([
    ContentChildren(SidemenuItemComponent_1),
    __metadata("design:type", QueryList)
], SidemenuItemComponent.prototype, "subElements", void 0);
SidemenuItemComponent = SidemenuItemComponent_1 = __decorate([ __param(2, Optional()), __param(2, SkipSelf()),
    __metadata("design:paramtypes", [SidemenuService,
        Router,
        SidemenuItemComponent])
], SidemenuItemComponent);

let AuthInterceptorService = class AuthInterceptorService {
    constructor(injector) {
        this.injector = injector;
    }
    intercept(req, next) {
        return next.handle(req).pipe(tap((event) => { }, (err) => {
            if (err instanceof HttpErrorResponse) {
                switch (err.status) {
                    case 401:
                        if (err.url.includes('/refreshaccesstoken')) {
                            this.injector.get(AuthService).login(err.url, true);
                        }
                        else {
                            console.log('Not authorized.');
                            this.injector.get(AuthService).login(err.url);
                        }
                        break;
                }
            }
        }));
    }
};
AuthInterceptorService.ɵfac = function AuthInterceptorService_Factory(t) { return new (t || AuthInterceptorService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector)); };
AuthInterceptorService.ctorParameters = () => [
    { type: Injector }
];
AuthInterceptorService.ɵprov = ɵɵdefineInjectable({ factory: function AuthInterceptorService_Factory() { return new AuthInterceptorService(ɵɵinject(INJECTOR)); }, token: AuthInterceptorService, providedIn: "root" });
AuthInterceptorService = __decorate([ __metadata("design:paramtypes", [Injector])
], AuthInterceptorService);

let TenantComponent = class TenantComponent {
    constructor(tenantService, appService) {
        this.tenantService = tenantService;
        this.appService = appService;
        this.mandatory = false;
        this.selectedTenantIdx = -1;
        this.style = 'maxHeight: \'500px\', \'overflow-y\': \'auto\', \'overflow-x\': \'hidden\'';
        this.open = false;
        this.tenantService.getTenantSelectionDlgState().subscribe(newState => {
            this.appName = this.appService.selected.name;
            if (!newState.open) {
                this.open = false;
                return;
            }
            this.mandatory = newState.mandatory;
            if (newState.error) {
                this.error = newState.error;
                this.open = true;
                return;
            }
            const selectedTenant = this.tenantService.getSelectedTenant();
            this.tenantService.getTenants().subscribe(ts => {
                this.tenantList = [];
                ts.forEach((t, indexAll) => this.tenantList.push({ label: t, value: indexAll }));
                if (this.appService.selected.multiTenant) {
                    this.selectedTenantIdListx = [];
                    if (selectedTenant !== undefined) {
                        selectedTenant.tenantList.forEach(t => {
                            const index = this.tenantList.findIndex(item => item.label === t);
                            this.selectedTenantIdListx.push({ label: t, value: index });
                        });
                    }
                    this.multiTenant = true;
                }
                else {
                    if (selectedTenant !== undefined) {
                        const index = this.tenantList.findIndex(item => item.label === selectedTenant.tenant);
                        this.selectedTenantIdx = index;
                    }
                    this.multiTenant = false;
                }
                this.open = true;
            });
        });
    }
    canSave() {
        if ((this.selectedTenantIdx !== undefined && this.selectedTenantIdx > -1) ||
            (this.selectedTenantIdListx !== undefined && this.selectedTenantIdListx.length > 0)) {
            return true;
        }
        return false;
    }
    save() {
        const saveList = [];
        if (!this.multiTenant) {
            saveList.push(this.tenantList[this.selectedTenantIdx].label);
        }
        else {
            for (let i = 0; i < this.selectedTenantIdListx.length; i++) {
                saveList.push(this.selectedTenantIdListx[i].label);
            }
        }
        this.tenantService.selectTenant(saveList);
        this.close();
    }
    close() {
        this.tenantService.closeTenantSelection();
    }
};
TenantComponent.ɵfac = function TenantComponent_Factory(t) { return new (t || TenantComponent)(ɵngcc0.ɵɵdirectiveInject(TenantService), ɵngcc0.ɵɵdirectiveInject(ApplicationService)); };
TenantComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TenantComponent, selectors: [["ki-tenant"]], decls: 11, vars: 19, consts: [[3, "visible", "modal", "responsive", "closable", "styleClass", "visibleChange"], [4, "ngIf"], ["type", "button", "pButton", "", 1, "ui-button-secondary", "ui-button", "ui-widget", "ui-state-default", "ui-corner-all", "ui-button-text-only", 2, "background-color", "#ffffff", "color", "#2d7693", 3, "label", "disabled", "click"], ["type", "button", "pButton", "", 2, "background-color", "#2d7693", "color", "#ffffff", 3, "label", "disabled", "click"], ["multiple", "multiple", "checkbox", "checkbox", "filter", "filter", "optionLabel", "label", 3, "options", "ngModel", "listStyle", "ngModelChange"], ["appendTo", "body", 3, "options", "ngModel", "filter", "placeholder", "ngModelChange"]], template: function TenantComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "p-dialog", 0);
        ɵngcc0.ɵɵlistener("visibleChange", function TenantComponent_Template_p_dialog_visibleChange_0_listener($event) { return ctx.open = $event; });
        ɵngcc0.ɵɵelementStart(1, "p-header");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, TenantComponent_div_4_Template, 3, 2, "div", 1);
        ɵngcc0.ɵɵtemplate(5, TenantComponent_div_5_Template, 2, 1, "div", 1);
        ɵngcc0.ɵɵelementStart(6, "p-footer");
        ɵngcc0.ɵɵelementStart(7, "button", 2);
        ɵngcc0.ɵɵlistener("click", function TenantComponent_Template_button_click_7_listener() { return ctx.close(); });
        ɵngcc0.ɵɵpipe(8, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "button", 3);
        ɵngcc0.ɵɵlistener("click", function TenantComponent_Template_button_click_9_listener() { return ctx.save(); });
        ɵngcc0.ɵɵpipe(10, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("visible", ctx.open)("modal", true)("responsive", true)("closable", !ctx.mandatory)("styleClass", ctx.style);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate2(" ", ɵngcc0.ɵɵpipeBind1(3, 13, "SELECT_TENANT_FOR"), " ", ctx.appName, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.error);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.error);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(8, 15, "CANCEL"));
        ɵngcc0.ɵɵproperty("disabled", ctx.mandatory);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵpropertyInterpolate("label", ɵngcc0.ɵɵpipeBind1(10, 17, "SAVE"));
        ɵngcc0.ɵɵproperty("disabled", !ctx.canSave());
    } }, directives: [ɵngcc9.Dialog, ɵngcc5.Header, ɵngcc2.NgIf, ɵngcc5.Footer, ɵngcc12.ButtonDirective, ɵngcc10.Listbox, ɵngcc11.NgControlStatus, ɵngcc11.NgModel, ɵngcc13.Dropdown], pipes: [ɵngcc4.TranslatePipe], styles: [".example-form[_ngcontent-%COMP%]{min-width:150px;max-width:500px;width:100%}.example-full-width[_ngcontent-%COMP%]{width:100%}[_nghost-%COMP%]     .ui-listbox .ui-listbox-header .ui-chkbox .ui-chkbox-box{border-color:#757575}[_nghost-%COMP%]     .ui-listbox .ui-listbox-header .ui-listbox-filter-container .ui-inputtext{color:#757575}"] });
TenantComponent.ctorParameters = () => [
    { type: TenantService },
    { type: ApplicationService }
];
TenantComponent = __decorate([ __metadata("design:paramtypes", [TenantService, ApplicationService])
], TenantComponent);

let LocaleService = class LocaleService {
    constructor() { }
    getLocale() {
        if (window === undefined || window.navigator === undefined) {
            return undefined;
        }
        let browserLang = window.navigator['languages'] ? window.navigator['languages'][0] : null;
        browserLang = browserLang || window.navigator.language || window.navigator['browserLanguage'] || window.navigator['userLanguage'];
        if (browserLang.indexOf('-') !== -1) {
            browserLang = browserLang.split('-')[0];
        }
        if (browserLang.indexOf('_') !== -1) {
            browserLang = browserLang.split('_')[0];
        }
        return browserLang;
    }
};
LocaleService.ɵfac = function LocaleService_Factory(t) { return new (t || LocaleService)(); };
LocaleService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: LocaleService, factory: LocaleService.ɵfac });
LocaleService = __decorate([ __metadata("design:paramtypes", [])
], LocaleService);

/**
 * The possible log levels.
 * LogLevel.Off is never emitted and only used with Logger.level property to disable logs.
 */
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Off"] = 0] = "Off";
    LogLevel[LogLevel["Error"] = 1] = "Error";
    LogLevel[LogLevel["Warning"] = 2] = "Warning";
    LogLevel[LogLevel["Info"] = 3] = "Info";
    LogLevel[LogLevel["Debug"] = 4] = "Debug";
})(LogLevel || (LogLevel = {}));
/**
 * Simple logger system with the possibility of registering custom outputs.
 *
 * 4 different log levels are provided, with corresponding methods:
 * - debug   : for debug information
 * - info    : for informative status of the application (success, ...)
 * - warning : for non-critical errors that do not prevent normal application behavior
 * - error   : for critical errors that prevent normal application behavior
 *
 * Example usage:
 * ```
 * import { Logger } from 'app/core/logger.service';
 *
 * const log = new Logger('myFile');
 * ...
 * log.debug('something happened');
 * ```
 *
 * To disable debug and info logs in production, add this snippet to your root component:
 * ```
 * export class AppComponent implements OnInit {
 *   ngOnInit() {
 *     if (environment.production) {
 *       Logger.enableProductionMode();
 *     }
 *     ...
 *   }
 * }
 *
 * If you want to process logs through other outputs than console, you can add LogOutput functions to Logger.outputs.
 */
class Logger {
    constructor(source) {
        this.source = source;
    }
    /**
     * Enables production mode.
     * Sets logging level to LogLevel.Warning.
     */
    static enableProductionMode() {
        Logger.level = LogLevel.Warning;
    }
    /**
     * Logs messages or objects  with the debug level.
     * Works the same as console.log().
     */
    debug(...objects) {
        this.log(console.log, LogLevel.Debug, objects);
    }
    /**
     * Logs messages or objects  with the info level.
     * Works the same as console.log().
     */
    info(...objects) {
        //  console.info is not allowed due to tslint
        this.log(console.log, LogLevel.Info, objects);
    }
    /**
     * Logs messages or objects  with the warning level.
     * Works the same as console.log().
     */
    warn(...objects) {
        this.log(console.warn, LogLevel.Warning, objects);
    }
    /**
     * Logs messages or objects  with the error level.
     * Works the same as console.log().
     */
    error(...objects) {
        this.log(console.error, LogLevel.Error, objects);
    }
    log(func, level, objects) {
        if (level <= Logger.level) {
            const log = this.source ? ['[' + this.source + ']'].concat(objects) : objects;
            func.apply(console, log);
            Logger.outputs.forEach((output) => output.apply(output, [this.source, level].concat(objects)));
        }
    }
}
/**
 * Current logging level.
 * Set it to LogLevel.Off to disable logs completely.
 */
Logger.level = LogLevel.Debug;
/**
 * Additional log outputs.
 */
Logger.outputs = [];

const logger = new Logger('LicenseService');
let LicenseService = class LicenseService {
    constructor(http, markdownService, domSanitizer) {
        this.http = http;
        this.markdownService = markdownService;
        this.domSanitizer = domSanitizer;
        this.licensePath = '/rest/energy/portal/licenses';
    }
    /**
     * Fetch all licenses of all third party frontend and backend packages
     * that are used within the application.
     */
    updateAll3rdPartyLicenses() {
        let allDependencies$;
        // (1) Fetch frontend dependencies and convert them to class ThirdPartyDependencies
        const frontendDependencies$ = this.getFrontendDependencies()
            .pipe(map(frontendDependencyList => {
            return frontendDependencyList.map(frontendDependency => {
                const dependencies = [];
                // The 'licenses' property may contain either a single string value or an array of string.
                let licensesArray;
                if (Array.isArray(frontendDependency.licenses)) {
                    // An array value like ['MIT', 'GPL']
                    licensesArray = frontendDependency.licenses;
                }
                else {
                    // A single value like 'MIT'
                    licensesArray = [frontendDependency.licenses];
                }
                // Create the license label, e.g. "MIT" or in case of multiple licenses "MIT, GPL"
                let fullLicenseLabels = '';
                licensesArray.forEach((frontendLicenceText, index) => {
                    if (index > 0) {
                        fullLicenseLabels += ', ';
                    }
                    fullLicenseLabels += frontendLicenceText;
                });
                // This is no longer an array because all licenses of a (frontend) dependency are now listed in fullLicenseLabels
                const dependency = {
                    name: frontendDependency.name,
                    version: frontendDependency.version,
                    license: {
                        name: fullLicenseLabels,
                        // Beware: this is the same text for all licenses:
                        text: this.sanitizeHtml(this.convertMarkdownToInsecureHtml(frontendDependency.licenseText)),
                        file: undefined,
                        url: undefined,
                        type: 'Front End'
                    }
                };
                dependencies.push(dependency);
                return dependencies;
            });
        }), 
        // Combine lists into single list
        // Hint: this only fetches the last items (of the arrays),
        // but this is okay because there is now only one ThirdPartyDependency for each frontendDependency.
        flatMap(results => combineLatest(results)), catchError(err => {
            logger.error('Error while getting 3rd party frontend dependency licenses. Handling error locally.', err);
            // Replacement must be an observable
            return of([]);
        }));
        // (2) Fetch backend dependencies and convert them to class ThirdPartyDependencies
        const backendDependencies$ = this.getBackendDependencies()
            .pipe(map(backendDependencyList => {
            return backendDependencyList.map(backendDependency => {
                const dependencies = [];
                backendDependency.licenses.forEach(backendLicence => {
                    const dependency = {
                        name: backendDependency.dependencyName,
                        version: backendDependency.version,
                        license: {
                            name: backendLicence.name,
                            text: undefined,
                            file: backendLicence.file,
                            url: backendLicence.url,
                            type: 'Back End'
                        }
                    };
                    dependencies.push(dependency);
                });
                return dependencies;
            });
        }), 
        // Combine lists into single list
        flatMap(results => {
            const backEndLicenses = [];
            results.forEach(licenses => {
                licenses.forEach(license => {
                    backEndLicenses.push(license);
                });
            });
            return of(backEndLicenses);
        }), catchError(err => {
            logger.error('Error while getting 3rd party frontend dependency licenses. Handling error locally.', err);
            // Replacement must be an observable
            return of([]);
        }));
        // (3) Combine both dependency lists (frontend and backend) into a single list
        allDependencies$ = forkJoin([frontendDependencies$, backendDependencies$])
            .pipe(catchError(err => {
            logger.error('Error while getting 3rd party frontend dependency licenses. Handling error locally and rethrowing it.', err);
            return throwError(err);
        }), map(([s1, s2]) => [...s1, ...s2]));
        return allDependencies$;
    }
    setBackendLicensePath(path) {
        this.licensePath = path;
    }
    getFrontendDependencies() {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        return this.http
            // TODO: do not locate the licenses inside the assets folder, because than it would be possible to download it even if
            // no user is logged in.
            .get('assets/licenses/frontend3rdPartyDependencies.json', { headers: headers })
            .pipe(map(frontendDependencyMap => {
            // Convert map to array
            const frontendDependencyList = Object.entries(frontendDependencyMap).map(([key, value]) => value);
            return frontendDependencyList;
        }));
    }
    getBackendDependencies() {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/vnd.energy.portal-v1.0+json; charset=UTF-8');
        return this.http
            .get(this.licensePath, { headers: headers });
    }
    getBackendDependencyLicenseText(licenseName) {
        const headers = new HttpHeaders();
        headers.append('Content-Type', 'application/vnd.energy.portal-v1.0+text, application/vnd.energy.portal-v1.0+text_html; charset=UTF-8');
        return this.http
            .get(this.licensePath + '/license/' + licenseName, { responseType: 'text' })
            .pipe(map(text => text));
    }
    getBackEndDependencyLicense(license) {
        if (license.file === null) {
            license.text = 'No license file could be retrieved for this package.';
        }
        else {
            this.getBackendDependencyLicenseText(license.file).subscribe(licenseText => {
                license.text = this.sanitizeHtml(this.convertMarkdownToInsecureHtml(licenseText));
            });
        }
    }
    convertMarkdownToInsecureHtml(content) {
        let contentHtml;
        if (content !== undefined) {
            contentHtml = this.markdownService.compile(content);
        }
        return contentHtml;
    }
    sanitizeHtml(contentHtml) {
        let safeContentHtml;
        if (contentHtml !== undefined) {
            safeContentHtml = this.domSanitizer.sanitize(SecurityContext.HTML, contentHtml);
        }
        return safeContentHtml;
    }
};
LicenseService.ɵfac = function LicenseService_Factory(t) { return new (t || LicenseService)(ɵngcc0.ɵɵinject(ɵngcc3.HttpClient), ɵngcc0.ɵɵinject(ɵngcc14.MarkdownService), ɵngcc0.ɵɵinject(ɵngcc15.DomSanitizer)); };
LicenseService.ctorParameters = () => [
    { type: HttpClient },
    { type: MarkdownService },
    { type: DomSanitizer }
];
LicenseService.ɵprov = ɵɵdefineInjectable({ factory: function LicenseService_Factory() { return new LicenseService(ɵɵinject(HttpClient), ɵɵinject(MarkdownService), ɵɵinject(DomSanitizer)); }, token: LicenseService, providedIn: "root" });
LicenseService = __decorate([ __metadata("design:paramtypes", [HttpClient,
        MarkdownService,
        DomSanitizer])
], LicenseService);

let LicenseViewerComponent = class LicenseViewerComponent {
    constructor(licenseService) {
        this.licenseService = licenseService;
        this.display = false;
        this.allDependencyLicensesSubject = new BehaviorSubject([]);
        this.allDependencyLicenses$ = this.allDependencyLicensesSubject.asObservable();
        this.columns = [
            { header: 'Package Name', field: 'name', type: 'string' },
            { header: 'Version', field: 'version', type: 'string' },
            { header: 'License', field: 'license.name', type: 'string' },
            { header: 'Package Type', field: 'license.type', type: 'string' }
        ];
    }
    ngOnInit() {
        // Load all licenses
        this.allDependencyLicenses$ = this.licenseService.updateAll3rdPartyLicenses();
    }
    onSelectLicense(event, license) {
        if (license.type === 'Back End') {
            this.licenseService.getBackEndDependencyLicense(license);
        }
        this.selectedLicense = license;
        this.showDialog();
    }
    showDialog() {
        this.display = true;
    }
};
LicenseViewerComponent.ɵfac = function LicenseViewerComponent_Factory(t) { return new (t || LicenseViewerComponent)(ɵngcc0.ɵɵdirectiveInject(LicenseService)); };
LicenseViewerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LicenseViewerComponent, selectors: [["ki-app-license-viewer"]], decls: 17, vars: 23, consts: [[1, "outer-panel"], [1, "topic-title"], [1, "topic-description"], [1, "topic-description-medium"], ["class", "license-table", "id", "license-table", "dataKey", "license-table", 3, "value", "lazy", "autoLayout", "sortField", "sortOrder", 4, "ngIf"], [3, "visible", "modal", "dismissableMask", "closeOnEscape", "responsive", "closable", "visibleChange"], ["class", "license-title", 4, "ngIf"], [3, "innerHtml"], ["id", "license-table", "dataKey", "license-table", 1, "license-table", 3, "value", "lazy", "autoLayout", "sortField", "sortOrder"], ["licensetable", ""], ["pTemplate", "header"], ["pTemplate", "body"], [3, "pSortableColumn", 4, "ngFor", "ngForOf"], [3, "ngSwitch", 4, "ngFor", "ngForOf"], [3, "pSortableColumn"], [3, "field"], [3, "ngSwitch"], ["pInputText", "", "type", "text", "class", "ki-single-line-input", 3, "input", 4, "ngSwitchCase"], ["pInputText", "", "type", "text", 1, "ki-single-line-input", 3, "input"], ["type", "button", "pButton", "", "icon", "fa fa-fw fa-eye", 3, "click", 4, "ngIf"], ["type", "button", "pButton", "", "icon", "fa fa-fw fa-eye", 3, "click"], [1, "license-title"]], template: function LicenseViewerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 3);
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div");
        ɵngcc0.ɵɵtemplate(11, LicenseViewerComponent_p_table_11_Template, 4, 5, "p-table", 4);
        ɵngcc0.ɵɵpipe(12, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(13, "p-dialog", 5);
        ɵngcc0.ɵɵlistener("visibleChange", function LicenseViewerComponent_Template_p_dialog_visibleChange_13_listener($event) { return ctx.display = $event; });
        ɵngcc0.ɵɵelementStart(14, "div");
        ɵngcc0.ɵɵtemplate(15, LicenseViewerComponent_div_15_Template, 2, 1, "div", 6);
        ɵngcc0.ɵɵelement(16, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 14, "LICENSES"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 16, "LICENSES_DESCRIPTION"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(9, 18, "LICENSES_ADDENDUM"), " ");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(12, 20, ctx.allDependencyLicenses$));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleMap(ɵngcc0.ɵɵpureFunction0(22, _c7));
        ɵngcc0.ɵɵproperty("visible", ctx.display)("modal", true)("dismissableMask", true)("closeOnEscape", true)("responsive", true)("closable", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.selectedLicense == null ? null : ctx.selectedLicense.file) !== null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("innerHtml", ctx.selectedLicense == null ? null : ctx.selectedLicense.text, ɵngcc0.ɵɵsanitizeHtml);
    } }, directives: [ɵngcc2.NgIf, ɵngcc9.Dialog, ɵngcc16.Table, ɵngcc5.PrimeTemplate, ɵngcc2.NgForOf, ɵngcc16.SortableColumn, ɵngcc16.SortIcon, ɵngcc2.NgSwitch, ɵngcc2.NgSwitchCase, ɵngcc12.ButtonDirective], pipes: [ɵngcc4.TranslatePipe, ɵngcc2.AsyncPipe], styles: [".topic-title[_ngcontent-%COMP%]{font-size:x-large;font-weight:700;margin-top:15px}.topic-description[_ngcontent-%COMP%]{font-size:large;margin-top:7px;margin-bottom:7px}.topic-description-medium[_ngcontent-%COMP%]{font-size:medium;margin-top:7px;margin-bottom:15px}.license-title[_ngcontent-%COMP%]{font-size:x-large;font-weight:700}[_nghost-%COMP%]     .ui-table .ui-table-thead>tr>th{padding:.3em .4em}"] });
LicenseViewerComponent.ctorParameters = () => [
    { type: LicenseService }
];
LicenseViewerComponent = __decorate([ __metadata("design:paramtypes", [LicenseService])
], LicenseViewerComponent);

const routes = [
    { path: 'licenses', pathMatch: 'full', component: LicenseViewerComponent },
    { path: '#/licenses', pathMatch: 'full', component: LicenseViewerComponent }
];
let EnergyFrameLibRoutingModule = class EnergyFrameLibRoutingModule {
};
EnergyFrameLibRoutingModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EnergyFrameLibRoutingModule });
EnergyFrameLibRoutingModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EnergyFrameLibRoutingModule_Factory(t) { return new (t || EnergyFrameLibRoutingModule)(); }, imports: [[RouterModule.forChild(routes)],
        RouterModule] });

let ContentComponent = class ContentComponent {
    constructor() { }
    ngOnInit() { }
};
ContentComponent.ɵfac = function ContentComponent_Factory(t) { return new (t || ContentComponent)(); };
ContentComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ContentComponent, selectors: [["ki-content"]], decls: 0, vars: 0, template: function ContentComponent_Template(rf, ctx) { }, styles: [".ki-content{position:relative;overflow-y:unset}.ki-content-expanded{left:unset;margin-left:2.79em}.ki-content-reduced{left:unset;margin-left:18.93em}"], encapsulation: 2 });
ContentComponent = __decorate([ __metadata("design:paramtypes", [])
], ContentComponent);

function localeIdFactory(localeService) {
    return localeService.getLocale();
}
/*export function localeInitializer(localeId: string) {
  const x = (): Promise<any> => {
    return new Promise((resolve, reject) => {
      import(`@angular/common/locales/${localeId}.js`).then(module => {
        registerLocaleData(module.default);
        resolve();
      }, reject);
    });
  };
  return x;
}*/
let EnergyFrameModule = class EnergyFrameModule {
    /**
     * Constructor.
     * @param router the angular router
     * @param authService authentication service
     * @param zone zone, used for ripple effect
     */
    constructor(router, authService, zone) {
        this.zone = zone;
        this.tenantRequired = true;
        // router.events.subscribe(event => {
        //   if (event instanceof NavigationStart && this.tenantRequired) {
        //     authService.openTenantSelection();
        //   }
        // });
        this.zone.runOutsideAngular(() => {
            this.bindRipple();
        });
    }
    ngAfterViewInit() {
        this.layoutContainer = (this.layoutContainerViewChild.nativeElement);
        setTimeout(() => {
            this.layoutMenuScrollerViewChild.moveBar();
        }, 100);
    }
    bindRipple() {
        this.rippleMouseDownListener = this.rippleMouseDown.bind(this);
        document.addEventListener('mousedown', this.rippleMouseDownListener, false);
    }
    rippleMouseDown(e) {
        for (let target = e.target; target && target !== this; target = target['parentNode']) {
            if (!this.isVisible(target)) {
                continue;
            }
            // Element.matches() -> https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
            if (this.selectorMatches(target, '.ripplelink, .ui-button')) {
                const element = target;
                this.rippleEffect(element, e);
                break;
            }
        }
    }
    selectorMatches(el, selector) {
        const p = Element.prototype;
        const f = p['matches'] ||
            p['webkitMatchesSelector'] ||
            p['mozMatchesSelector'] ||
            p['msMatchesSelector'] ||
            function (s) {
                return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
            };
        return f.call(el, selector);
    }
    isVisible(el) {
        return !!(el.offsetWidth || el.offsetHeight);
    }
    rippleEffect(element, e) {
        if (this.hasClass(element, 'no-ripple') || this.hasClass(element, 'ui-state-disabled') || element.disabled) {
            return;
        }
        if (element.querySelector('.ink') === null) {
            const inkEl = document.createElement('span');
            this.addClass(inkEl, 'ink');
            if (this.hasClass(element, 'ripplelink')) {
                element
                    .querySelector('span')
                    .insertAdjacentHTML('afterend', "<span class='ink'></span>");
            }
            else {
                element.appendChild(inkEl);
            }
        }
        const ink = element.querySelector('.ink');
        this.removeClass(ink, 'ripple-animate');
        if (!ink.offsetHeight && !ink.offsetWidth) {
            const d = Math.max(element.offsetWidth, element.offsetHeight);
            ink.style.height = d + 'px';
            ink.style.width = d + 'px';
        }
        const x = e.pageX - this.getOffset(element).left - ink.offsetWidth / 2;
        const y = e.pageY - this.getOffset(element).top - ink.offsetHeight / 2;
        ink.style.top = y + 'px';
        ink.style.left = x + 'px';
        ink.style.pointerEvents = 'none';
        this.addClass(ink, 'ripple-animate');
    }
    hasClass(element, className) {
        if (element.classList) {
            return element.classList.contains(className);
        }
        else {
            return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
        }
    }
    addClass(element, className) {
        if (element.classList) {
            element.classList.add(className);
        }
        else {
            element.className += ' ' + className;
        }
    }
    removeClass(element, className) {
        if (element.classList) {
            element.classList.remove(className);
        }
        else {
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }
    getOffset(el) {
        const rect = el.getBoundingClientRect();
        return {
            top: rect.top +
                (window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop ||
                    0),
            left: rect.left +
                (window.pageXOffset ||
                    document.documentElement.scrollLeft ||
                    document.body.scrollLeft ||
                    0)
        };
    }
    unbindRipple() {
        if (this.rippleMouseDownListener) {
            document.removeEventListener('mousedown', this.rippleMouseDownListener);
        }
    }
    ngOnDestroy() {
        this.unbindRipple();
    }
};
EnergyFrameModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EnergyFrameModule, bootstrap: function () { return [TenantComponent]; } });
EnergyFrameModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EnergyFrameModule_Factory(t) { return new (t || EnergyFrameModule)(ɵngcc0.ɵɵinject(ɵngcc1.Router), ɵngcc0.ɵɵinject(AuthService), ɵngcc0.ɵɵinject(ɵngcc0.NgZone)); }, providers: [
        SidemenuService,
        AuthService,
        TenantService,
        ParameterService,
        HelpService,
        WindowRef,
        LanguageService,
        TranslateService,
        ThemeService,
        Location,
        ApplicationService,
        MarkdownService,
        LocaleService,
        AuthInterceptorService,
        MessageService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true
        },
        { provide: 'LOCALSTORAGE', useFactory: getLocalStorage },
        {
            provide: LOCALE_ID,
            useFactory: localeIdFactory,
            deps: [LocaleService]
        }
    ], imports: [[
            BrowserModule,
            BrowserAnimationsModule,
            FormsModule,
            ReactiveFormsModule,
            DropdownModule,
            ListboxModule,
            DialogModule,
            ButtonModule,
            ToastModule,
            TooltipModule,
            RouterModule,
            EnergyFrameLibRoutingModule,
            MenuModule,
            OverlayPanelModule,
            MarkdownModule.forRoot(),
            TableModule,
            TranslateModule
        ]] });
EnergyFrameModule.ctorParameters = () => [
    { type: Router },
    { type: AuthService },
    { type: NgZone }
];
__decorate([
    ViewChild('layoutContainer'),
    __metadata("design:type", ElementRef)
], EnergyFrameModule.prototype, "layoutContainerViewChild", void 0);
__decorate([
    ViewChild('scrollPanel'),
    __metadata("design:type", ScrollPanel)
], EnergyFrameModule.prototype, "layoutMenuScrollerViewChild", void 0);
EnergyFrameModule = __decorate([ __metadata("design:paramtypes", [Router, AuthService, NgZone])
], EnergyFrameModule);
function getLocalStorage() {
    return typeof window !== 'undefined' ? window.localStorage : null;
}

/**
 * Custom (multi-file) HttpLoader for translation files.
 */
class EnergyTranslateHttpLoader {
    /**
     * Constructor.
     * @param http HttpClient
     * @param resources Array of files to be loaded and parsed for translated strings
     */
    constructor(http, resources) {
        this.http = http;
        this.resources = resources;
    }
    /**
     * Get a joined and merged result of translations from all configured files.
     * @param lang current language
     */
    getTranslation(lang) {
        const requests = this.resources.map(resource => {
            const target = resource.path + resource.file + '_' + lang + '.json';
            return this.http.get(target).pipe(catchError(res => {
                console.error('Could not find translation file:', target);
                return of({});
            }));
        });
        return forkJoin(requests).pipe(map(response => all(response)));
    }
}

// the translation file of this library
const frameModuleFile = {
    path: './assets/i18n/',
    file: 'energyFrameModule'
};
// InjectionToken for receiving the resources array from outside the EnergyTranslateModule
const ResourceHolder = new InjectionToken('');
/**
 * Injectable, used to receive the array of files to be loaded for translation from outside the
 * EnergyTranslateModule and provide it to the HttpLoader.
 */
let TranslationResourceInjectable = class TranslationResourceInjectable {
    /**
     * Constructor.
     * @param i18nResources the array of files that shall be loaded for translation (given in forRoot())
     */
    constructor(i18nResources) {
        this.res = i18nResources;
        // add the translation file of energy-frame-module
        this.res.push(frameModuleFile);
    }
    /**
     * Return the list of translation files.
     */
    getResources() {
        return this.res;
    }
};
TranslationResourceInjectable.ɵfac = function TranslationResourceInjectable_Factory(t) { return new (t || TranslationResourceInjectable)(ɵngcc0.ɵɵinject(ResourceHolder)); };
TranslationResourceInjectable.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: TranslationResourceInjectable, factory: TranslationResourceInjectable.ɵfac });
TranslationResourceInjectable.ctorParameters = () => [
    { type: Array, decorators: [{ type: Inject, args: [ResourceHolder,] }] }
];
TranslationResourceInjectable = __decorate([ __param(0, Inject(ResourceHolder)),
    __metadata("design:paramtypes", [Array])
], TranslationResourceInjectable);

var EnergyTranslateModule_1;
/**
 * Factory creating a custom HttpLoader
 * @param http HttpClient
 * @param resourceInjectable TranslationResourceInjectable which will provide the list of files to be loaded
 */
function HttpLoaderFactory(http, resourceInjectable) {
    return new EnergyTranslateHttpLoader(http, resourceInjectable.getResources());
}
/**
 * Module declaration.
 * It configures ngx-translate with a custom HttpLoader from our factory where
 * TranslationResourceInjectable is injected, handing over the list of files from the outside.
 */
let EnergyTranslateModule = EnergyTranslateModule_1 = 
/**
 * Module class.
 */
class EnergyTranslateModule {
    /**
     * The forRoot method can receive a list of files to be loaded for translation,
     * when importing the EnergyTranslateModule in an AppModule.
     * @param resources the array of files to be loaded for translation
     */
    static forRoot(resources) {
        return {
            ngModule: EnergyTranslateModule_1,
            providers: [
                TranslationResourceInjectable,
                {
                    provide: ResourceHolder,
                    useValue: resources
                }
            ]
        };
    }
};
EnergyTranslateModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EnergyTranslateModule });
EnergyTranslateModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EnergyTranslateModule_Factory(t) { return new (t || EnergyTranslateModule)(); }, imports: [[
            CommonModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient, TranslationResourceInjectable]
                }
            })
        ]] });

let EnergyTranslatePipeMock = class EnergyTranslatePipeMock {
    constructor() {
        this.name = 'translate';
    }
    transform(query, ...args) {
        return query;
    }
};
EnergyTranslatePipeMock.ɵfac = function EnergyTranslatePipeMock_Factory(t) { return new (t || EnergyTranslatePipeMock)(); };
EnergyTranslatePipeMock.ɵpipe = ɵngcc0.ɵɵdefinePipe({ name: "translate", type: EnergyTranslatePipeMock, pure: true });
let EnergyTranslateServiceStub = class EnergyTranslateServiceStub {
    get(key) {
        return of(key);
    }
    setDefaultLang(key) { }
    use(key) { }
};
EnergyTranslateServiceStub.ɵfac = function EnergyTranslateServiceStub_Factory(t) { return new (t || EnergyTranslateServiceStub)(); };
EnergyTranslateServiceStub.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: EnergyTranslateServiceStub, factory: EnergyTranslateServiceStub.ɵfac });
// @dynamic
let EnergyTranslateTestingModule = class EnergyTranslateTestingModule {
};
EnergyTranslateTestingModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: EnergyTranslateTestingModule });
EnergyTranslateTestingModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function EnergyTranslateTestingModule_Factory(t) { return new (t || EnergyTranslateTestingModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidemenuService, [{
        type: Injectable
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ParameterService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.Router }, { type: ɵngcc2.Location }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: ParameterService }]; }, { selectedAppUpdated: [{
            type: Output
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ApplicationService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: ParameterService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(KiNumberPipe, [{
        type: Pipe,
        args: [{
                name: 'kiNumber',
                pure: false
            }]
    }], function () { return [{ type: ɵngcc4.TranslateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(KiDatePipe, [{
        type: Pipe,
        args: [{
                name: 'kiDate',
                pure: false
            }]
    }], function () { return [{ type: ɵngcc4.TranslateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LanguageService, [{
        type: Injectable
    }], function () { return [{ type: ParameterService }, { type: undefined, decorators: [{
                type: Inject,
                args: ['LOCALSTORAGE']
            }] }, { type: ɵngcc4.TranslateService }]; }, { languageChanged: [{
            type: Output
        }], displaySelectionDialog: [{
            type: Output
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(WindowRef, [{
        type: Injectable
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HelpService, [{
        type: Injectable
    }], function () { return [{ type: AuthService }, { type: ɵngcc3.HttpClient }, { type: WindowRef }, { type: ɵngcc1.ActivatedRoute }, { type: ɵngcc1.Router }, { type: LanguageService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ThemeService, [{
        type: Injectable
    }], function () { return [{ type: ParameterService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TenantService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: ParameterService }, { type: ApplicationService }, { type: ɵngcc4.TranslateService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(VersionsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'ki-header',
                template: "<div>\n  <ki-content></ki-content>\n  <ki-language-selection></ki-language-selection>\n  <p-menu\n    #appMenu\n    popup=\"true\"\n    [appendTo]=\"appDiv\"\n    [model]=\"menuItems\"\n    [style]=\"{ position: 'fixed', width: '30em' }\"\n  ></p-menu>\n  <p-menu\n    #userMenu\n    popup=\"true\"\n    [appendTo]=\"userDiv\"\n    [model]=\"userMenuItems\"\n    [style]=\"{ position: 'fixed', width: '24em' }\"\n  ></p-menu>\n  <div id=\"ki-logo-area\">\n    <div id=\"ki-logo\" title=\"Startseite\">\n      <img id=\"logoArea\" src=\"\" alt=\"LOGO\" style=\"height: 31px; width: 184px\" />\n    </div>\n    <div\n      #appDiv\n      id=\"app-div\"\n      class=\"ui-cursor\"\n      (click)=\"checkApplications(); appMenu.toggle($event)\"\n      [hidden]=\"bHideApplications\"\n    >\n      <span class=\"ki-bold\">{{ selectedApplication.area }}</span>\n      <span style=\"margin-left: 0.5em\">{{ selectedApplication.name }}</span>\n      <i class=\"ki-applist-icon-color ki-margin5 fa fa-chevron-down\"></i>\n    </div>\n    <div #userDiv id=\"user-div\">\n      <span *ngIf=\"displayTenant !== null && !bHideLogin\" class=\"ui-cursor\">\n        <span\n          [pTooltip]=\"tenantMultiLineTooltip\"\n          [escape]=\"false\"\n          tooltipPosition=\"bottom\"\n          (click)=\"openTenantSelection()\"\n          >{{ displayTenant }} |</span\n        >\n      </span>\n      <span\n        class=\"ki-margin5 ui-cursor\"\n        (click)=\"userMenu.toggle($event)\"\n        [ngSwitch]=\"bHideLogin\"\n      >\n        <i class=\"fa fa-user\" aria-hidden=\"true\"></i>\n        <span class=\"user-menu-label\" *ngSwitchCase=\"false\">{{\n          loginInfo.username || 'SIGN_IN' | translate\n        }}</span>\n        <span class=\"user-menu-label\" *ngSwitchCase=\"true\">{{\n          'SETTINGS' | translate\n        }}</span>\n        <i class=\"ki-margin5 fa fa-chevron-down\" aria-hidden=\"true\"></i>\n      </span>\n      <i\n        *ngIf=\"!bHideHelp\"\n        class=\"fa fa-question-circle ui-cursor\"\n        style=\"margin-left: 10px\"\n        aria-hidden=\"true\"\n        (click)=\"callHelp(undefined)\"\n        ki-animate\n      ></i>\n    </div>\n  </div>\n  <ki-tenant></ki-tenant>\n  <p-toast></p-toast>\n</div>\n",
                styles: [".ki-menulist{position:absolute;top:100%;left:-8.5714286em;z-index:1000;float:left;min-width:17.8571429em;text-align:left}.ki-menulist-item{cursor:pointer;cursor:hand;padding:.3571429em}.ki-menulist-subItem{padding-left:1.78571429em}.ki-applist{display:table;position:absolute;z-index:1000;left:11.07142858em;margin-top:.14285715em;padding-top:.357142858em;padding-bottom:.357142858em}.ki-applist-item{display:table-row;text-decoration:none}.ki-applist-item div{display:table-cell;padding:.357142858em}.ki-frame-user-bar{position:absolute;right:2.14285715em;bottom:0}.ki-frame-user-bar>i{font-size:1.28571429em;margin-right:.21428571429em}.ki-frame-user-bar>span>i{font-size:1.28571429em}.ki-margin5{margin-left:.357142858em}#ki-logo-area{position:fixed;top:0;left:0;height:50px;width:100%;min-width:0;z-index:2}#ki-logo{position:absolute;display:block;margin-right:15px;left:15px;background-repeat:no-repeat;width:184px;height:31px;border:none;outline:0;bottom:7px}#app-div{position:absolute;left:230px;bottom:3px;right:unset;font-family:\"Open Sans\";font-weight:400;line-height:normal;font-size:16px}#user-div{position:absolute;right:30px;bottom:3px;font-family:\"Open Sans\";font-weight:400;line-height:normal;font-size:16px}:host ::ng-deep .ui-menu{width:25em;font-size:14px;padding:0}:host ::ng-deep .ui-menu .ui-submenu-header{padding:.56em 1em}:host ::ng-deep .ui-menu .ui-menuitem-link{padding:.56em 1em}:host ::ng-deep .ui-menu .ui-menuitem-icon{width:1.5em}:host ::ng-deep .ui-menu.ui-menu-dynamic{top:47px!important;display:block!important}.ui-cursor{cursor:pointer}.user-menu-label{margin-left:.25em;margin-right:.25em}"]
            }]
    }], function () { return [{ type: AuthService }, { type: TenantService }, { type: ApplicationService }, { type: ParameterService }, { type: HelpService }, { type: LanguageService }, { type: ThemeService }, { type: ɵngcc4.TranslateService }, { type: VersionsService }, { type: ɵngcc1.Router }, { type: ɵngcc5.MessageService }]; }, { hideHelp: [{
            type: Input
        }], hideLogin: [{
            type: Input
        }], hideApplications: [{
            type: Input
        }], onlyDefaultLanguages: [{
            type: Input
        }], hideThemes: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LanguageSelectionComponent, [{
        type: Component,
        args: [{
                selector: 'ki-language-selection',
                template: "<p-dialog header=\"Select your Language\" [closable]=\"false\" [modal]=\"true\" [(visible)]=\"display\">\n    <div>\n        <div>\n            <p-listbox [options]=\"options\" [(ngModel)]=\"selected\"></p-listbox>\n        </div>\n        <div style=\"margin-top: 1.429em\">\n            <button style=\"float: right\" pButton (click)='save()' type=\"button\" label=\"OK\"></button>\n        </div>\n    </div>\n</p-dialog>",
                styles: [""]
            }]
    }], function () { return [{ type: LanguageService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidemenuComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'ki-sidemenu',
                template: "<div\n  class=\"ki-side-menu ki-sidemenu-border\"\n  [ngClass]=\"\n    sidemenuService.isReduced ? 'ki-side-menu-reduced' : 'ki-side-menu-expand'\n  \"\n>\n  <div style=\"background-color: #ffffff; height: 2.5em\">\n    <span class=\"ki-menu-toggle\" (click)=\"toggle()\" title=\"{{ getTitle() }}\">\n      <i class=\"fa fa-bars\"></i>\n    </span>\n  </div>\n\n  <div class=\"ki-menu-list\">\n    <div>\n      <ng-content select=\"ki-sidemenu-item\"></ng-content>\n    </div>\n  </div>\n\n  <div>\n    <div *ngIf=\"!bHideVersion\" [ngSwitch]=\"sidemenuService.isReduced\">\n      <div *ngSwitchCase=\"false\">\n        <div\n          class=\"version\"\n          tabindex=\"-1\"\n          pTooltip=\"{{\n            !version ? ('VERSION_NOT_FOUND' | translate) : version\n          }}\"\n          [escape]=\"false\"\n          tooltipPosition=\"top\"\n        >\n          {{\n            useInfraVersion === true\n              ? ('INFRASTRUCTURE_VERSION_TITLE' | translate)\n              : ('APP_VERSION_TITLE' | translate)\n          }}:&nbsp;{{ versionShort }}\n        </div>\n      </div>\n      <div *ngSwitchCase=\"true\">\n        <div class=\"version-icon\">\n          <i class=\"fa fa-info-circle\" title=\"Version:&nbsp;{{ version }}\"></i>\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n",
                styles: [".ki-side-menu{position:fixed;z-index:1;box-sizing:border-box;border-right:2px solid #d3d3d3;float:left;top:50px;bottom:0;-webkit-padding-start:0;overflow-x:hidden;overflow-y:hidden}.version{font-size:.8em;padding-left:7px;position:absolute;cursor:default;z-index:5;background-color:#fff;bottom:0;padding-bottom:.3571428571em;width:90%}.version-icon{bottom:5px;position:absolute;padding-left:13px;cursor:default;z-index:5}.ki-side-menu-reduced{width:2.79em}.ki-side-menu-expand{width:18.93em}.ki-menu-toggle{float:right;padding-top:10px;padding-right:10px;padding-left:10px;cursor:pointer;cursor:hand;position:sticky;position:-webkit-sticky;top:0;z-index:5}.ki-menu-list{margin-top:0;padding-left:0;left:-120px;list-style:none;overflow-y:auto;overflow-x:hidden;max-height:92%}"]
            }]
    }], function () { return [{ type: SidemenuService }, { type: VersionsService }]; }, { version: [{
            type: Input
        }], useInfraVersion: [{
            type: Input
        }], hideVersion: [{
            type: Input
        }], initiallyReduced: [{
            type: Input
        }], infraComponentKey: [{
            type: Input
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SidemenuItemComponent, [{
        type: Component,
        args: [{
                selector: 'ki-sidemenu-item',
                template: "<div class=\"ki-menu-item\" [ngClass]=\"isSelected ? 'ki-menu-item-selected' : ''\" tabindex=\"1\">\n  <span *ngIf=\"isSelected\" class=\"ki-menu-item-selected-marker\"></span>\n  <a\n    class=\"ui-g\"\n    style=\"text-decoration: none;\"\n    [routerLink]=\"link\"\n    [fragment]=\"fragment\"\n    [queryParams]=\"params\"\n    routerLinkActive=\"active\"\n    name=\"{{ name }}\"\n    (click)=\"openSub()\"\n  >\n    <span *ngIf=\"icon !== undefined || image !== undefined\" class=\"ui-g-1 no-padding\" [ngClass]=\"sideMenuReduced ? 'fa-stack' : ''\">\n      <i [ngClass]=mainIconClasses tabindex=\"-1\"></i>\n      <i *ngIf=\"sideMenuReduced && statusIcon\" class=\"{{statusIcon.iconClass}} fa-stack-1x reduced-menu-status-icon\"></i>\n    </span>\n    <span *ngIf=\"!sideMenuReduced\" class=\"ui-g-10 no-padding ki-menu-item-label\">{{ label }} <i *ngIf=\"statusIcon\" class=\"{{statusIcon.iconClass}} pull-right\" [ngClass]=\"isSubItem ? 'sub-item-status-icon' : 'item-status-icon'\" title=\"{{statusIcon.iconTooltip}}\"></i></span>\n  </a>\n  <span>\n    <i *ngIf=\"!sideMenuReduced && hasSubmenu === 'true'\"\n      class=\"item-chevron\" \n      [ngClass]=\"\n        showSubmenu\n          ? 'fa fa-angle-down pull-right ki-sub-menu-toggle'\n          :  'fa fa-angle-right pull-right ki-sub-menu-toggle'\n          \"\n      (click)=\"toggleSub()\"\n    ></i>\n  </span>\n</div>\n<div [ngClass]=\"sideMenuReduced ? 'ki-menu-sub-list-reduced' : 'ki-menu-sub-list'\" *ngIf=\"showSubmenu\">\n  <ng-content></ng-content>\n</div>\n",
                styles: [".ki-menu-icon{margin:2px 10px 2px 0;cursor:pointer}.ki-menu-icon:disabled{cursor:default}.ki-menu-sub-list{padding-left:20px}.ki-sub-menu-toggle{float:right;top:6px;right:4px;cursor:pointer;cursor:hand;position:absolute;padding:5px 10px}.ki-menu-item{position:relative;padding-left:15px;padding-top:8px;padding-bottom:8px;z-index:2}.ki-menu-item-selected-marker{position:absolute;top:0;bottom:0;margin-right:5px;margin-left:-15px;padding-left:5px}.ki-menu-sub-list .ki-menu-item-selected-marker{padding-left:25px;margin-left:-35px}.ki-menu-item-label{text-overflow:ellipsis;overflow:hidden;white-space:nowrap;margin-left:5px;width:12.86em;display:inline-block;vertical-align:bottom}.ki-menu-item:not(.ki-menu-item-selected) a span:hover,.ki-menu-item:not(.ki-menu-item-selected)>a:focus{text-decoration:none}.no-padding{padding:0;padding:unset}.item-chevron{margin-top:.1em}.item-status-icon{margin-top:.3em;margin-right:.8em}.sub-item-status-icon{margin-top:.3em;margin-right:.1em}.reduced-menu-status-icon{text-align:unset;margin-left:.6em;margin-top:.6em}::ng-deep .fa-stack{height:unset;line-height:unset}"]
            }]
    }], function () { return [{ type: SidemenuService }, { type: ɵngcc1.Router }, { type: SidemenuItemComponent, decorators: [{
                type: Optional
            }, {
                type: SkipSelf
            }] }]; }, { label: [{
            type: Input
        }], name: [{
            type: Input
        }], icon: [{
            type: Input
        }], image: [{
            type: Input
        }], link: [{
            type: Input
        }], fragment: [{
            type: Input
        }], params: [{
            type: Input
        }], hasSubmenu: [{
            type: Input
        }], statusIcon: [{
            type: Input
        }], subElements: [{
            type: ContentChildren,
            args: [SidemenuItemComponent_1]
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AuthInterceptorService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc0.Injector }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TenantComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line:component-selector
                selector: 'ki-tenant',
                template: "<p-dialog [(visible)]='open' [modal]='true' [responsive]=\"true\" [closable]=\"!this.mandatory\"\n    [styleClass]='style'>\n    <p-header>\n        {{ \"SELECT_TENANT_FOR\" | translate }} {{ appName }}\n    </p-header>\n    <div *ngIf='!error'>\n        <div *ngIf='multiTenant'>\n            <p-listbox [options]=\"tenantList\" [(ngModel)]=\"selectedTenantIdListx\"\n                [listStyle]=\"{'max-height':'250px', 'overflow-y': 'auto', 'overflow-x': 'hidden'}\" [style]=\"{'minWidth': '400px'}\"\n                multiple=\"multiple\" checkbox=\"checkbox\" filter=\"filter\" optionLabel=\"label\"></p-listbox>\n        </div>\n        <div *ngIf='!multiTenant'>\n            <p-dropdown [style]=\"{'minWidth': '400px'}\" appendTo=\"body\" [options]=\"tenantList\" [(ngModel)]=\"selectedTenantIdx\"\n            [filter]=\"true\" placeholder='{{ \"SELECT_TENANT\" | translate }}'></p-dropdown>\n        </div>\n    </div>\n    <div *ngIf='error'>\n        {{ error }}\n    </div>\n    <p-footer>\n        <button style=\"background-color: #ffffff; color: #2d7693\" class=\"ui-button-secondary ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only\"\n        type=\"button\" pButton (click)=\"close()\" label=\"{{ 'CANCEL' | translate }}\" [disabled]=\"this.mandatory\"></button>\n        <button style=\"background-color: #2d7693; color: #ffffff\" type=\"button\" pButton (click)=\"save()\" label=\"{{ 'SAVE' | translate }}\" [disabled]=\"!canSave()\"></button>\n    </p-footer>\n</p-dialog>",
                styles: [".example-form{min-width:150px;max-width:500px;width:100%}.example-full-width{width:100%}:host ::ng-deep .ui-listbox .ui-listbox-header .ui-chkbox .ui-chkbox-box{border-color:#757575}:host ::ng-deep .ui-listbox .ui-listbox-header .ui-listbox-filter-container .ui-inputtext{color:#757575}"]
            }]
    }], function () { return [{ type: TenantService }, { type: ApplicationService }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LocaleService, [{
        type: Injectable
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LicenseService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc3.HttpClient }, { type: ɵngcc14.MarkdownService }, { type: ɵngcc15.DomSanitizer }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LicenseViewerComponent, [{
        type: Component,
        args: [{
                selector: 'ki-app-license-viewer',
                template: "<div class=\"outer-panel\">\n  <div class=\"topic-title\">\n    {{ \"LICENSES\" | translate }}\n  </div>\n  <div class=\"topic-description\">\n    {{ \"LICENSES_DESCRIPTION\" | translate }}\n  </div>\n  <div class=\"topic-description-medium\">\n    {{ \"LICENSES_ADDENDUM\" | translate }}\n  </div>\n\n  <div>\n    <p-table #licensetable class=\"license-table\" id=\"license-table\" dataKey=\"license-table\"\n    *ngIf=\"this.allDependencyLicenses$ | async as thirdPartyLicenses\" [value]=\"thirdPartyLicenses\"\n    [lazy]=\"false\" [autoLayout]=\"true\" [sortField]=\"'name'\" [sortOrder]=\"1\">\n      <ng-template pTemplate=\"header\">\n        <tr>\n          <th *ngFor=\"let col of columns\" [pSortableColumn]=\"col.field\">\n            {{col.header}}\n            <p-sortIcon [field]=\"col.field\"></p-sortIcon>\n          </th>\n        </tr>\n        <tr>\n          <th *ngFor=\"let col of columns\" [ngSwitch]=\"col.type\">\n            <input *ngSwitchCase=\"'string'\" pInputText type=\"text\" class=\"ki-single-line-input\"\n              (input)=\"licensetable.filter($event.target.value, col.field, 'contains')\">\n            </th>\n        </tr>\n      </ng-template>\n      <ng-template pTemplate=\"body\" let-package>\n        <tr>\n          <td>\n            <button\n              *ngIf=\"package?.license !== undefined\"\n              type=\"button\"\n              pButton\n              (click)=\"onSelectLicense($event, package.license)\"\n              icon=\"fa fa-fw fa-eye\">\n            </button>\n            {{ package?.name }}</td>\n          <td>{{ package?.version }}</td>\n          <td>\n            {{ package?.license?.name }}\n          </td>\n          <td>{{ package?.license?.type }}</td>\n        </tr>\n      </ng-template>\n    </p-table>\n  </div>\n\n  <!-- Display the content of the license (as HTML) -->\n  <p-dialog\n  [(visible)]=\"display\" [modal]=\"true\" [dismissableMask]=\"true\" [closeOnEscape]=\"true\" [responsive]=\"true\"\n  [closable]=\"true\" [style]=\"{width: '990px', maxHeight: '500px',  minHeight: '200px', 'overflow-y': 'auto', 'overflow-x': 'hidden'}\">\n    <div>\n      <!-- Show licence title -->\n      <div *ngIf=\"selectedLicense?.file !== null\" class=\"license-title\">\n        {{ selectedLicense?.name }}\n      </div>\n      <!-- Show licence content as HTML -->\n      <div [innerHtml]=\"selectedLicense?.text\">\n      </div>\n    </div>\n  </p-dialog>\n</div>\n",
                styles: [".topic-title{font-size:x-large;font-weight:700;margin-top:15px}.topic-description{font-size:large;margin-top:7px;margin-bottom:7px}.topic-description-medium{font-size:medium;margin-top:7px;margin-bottom:15px}.license-title{font-size:x-large;font-weight:700}:host ::ng-deep .ui-table .ui-table-thead>tr>th{padding:.3em .4em}"]
            }]
    }], function () { return [{ type: LicenseService }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EnergyFrameLibRoutingModule, { imports: function () { return [ɵngcc1.RouterModule]; }, exports: function () { return [RouterModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EnergyFrameLibRoutingModule, [{
        type: NgModule,
        args: [{
                imports: [RouterModule.forChild(routes)],
                exports: [RouterModule]
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(ContentComponent, [{
        type: Component,
        args: [{
                selector: 'ki-content',
                template: "<!-- currently empty 'global' component. this could be extended to be used by applications instead of setting ki-content classes -->\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".ki-content{position:relative;overflow-y:unset}.ki-content-expanded{left:unset;margin-left:2.79em}.ki-content-reduced{left:unset;margin-left:18.93em}"]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EnergyFrameModule, { declarations: function () { return [HeaderComponent,
        SidemenuComponent,
        SidemenuItemComponent,
        TenantComponent,
        KiDatePipe,
        KiNumberPipe,
        LicenseViewerComponent,
        ContentComponent,
        LanguageSelectionComponent]; }, imports: function () { return [BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        DropdownModule,
        ListboxModule,
        DialogModule,
        ButtonModule,
        ToastModule,
        TooltipModule,
        RouterModule,
        EnergyFrameLibRoutingModule,
        MenuModule,
        OverlayPanelModule, ɵngcc14.MarkdownModule, TableModule,
        TranslateModule]; }, exports: function () { return [HeaderComponent,
        SidemenuComponent,
        SidemenuItemComponent,
        TenantComponent,
        KiDatePipe,
        KiNumberPipe,
        LicenseViewerComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EnergyFrameModule, [{
        type: NgModule,
        args: [{
                imports: [
                    BrowserModule,
                    BrowserAnimationsModule,
                    FormsModule,
                    ReactiveFormsModule,
                    DropdownModule,
                    ListboxModule,
                    DialogModule,
                    ButtonModule,
                    ToastModule,
                    TooltipModule,
                    RouterModule,
                    EnergyFrameLibRoutingModule,
                    MenuModule,
                    OverlayPanelModule,
                    MarkdownModule.forRoot(),
                    TableModule,
                    TranslateModule
                ],
                declarations: [
                    HeaderComponent,
                    SidemenuComponent,
                    SidemenuItemComponent,
                    TenantComponent,
                    KiDatePipe,
                    KiNumberPipe,
                    LicenseViewerComponent,
                    ContentComponent,
                    LanguageSelectionComponent
                ],
                exports: [
                    HeaderComponent,
                    SidemenuComponent,
                    SidemenuItemComponent,
                    TenantComponent,
                    KiDatePipe,
                    KiNumberPipe,
                    LicenseViewerComponent
                ],
                providers: [
                    SidemenuService,
                    AuthService,
                    TenantService,
                    ParameterService,
                    HelpService,
                    WindowRef,
                    LanguageService,
                    TranslateService,
                    ThemeService,
                    Location,
                    ApplicationService,
                    MarkdownService,
                    LocaleService,
                    AuthInterceptorService,
                    MessageService,
                    {
                        provide: HTTP_INTERCEPTORS,
                        useClass: AuthInterceptorService,
                        multi: true
                    },
                    { provide: 'LOCALSTORAGE', useFactory: getLocalStorage },
                    {
                        provide: LOCALE_ID,
                        useFactory: localeIdFactory,
                        deps: [LocaleService]
                    }
                ],
                entryComponents: [TenantComponent],
                bootstrap: [TenantComponent],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], function () { return [{ type: ɵngcc1.Router }, { type: AuthService }, { type: ɵngcc0.NgZone }]; }, { layoutContainerViewChild: [{
            type: ViewChild,
            args: ['layoutContainer']
        }], layoutMenuScrollerViewChild: [{
            type: ViewChild,
            args: ['scrollPanel']
        }] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TranslationResourceInjectable, [{
        type: Injectable
    }], function () { return [{ type: Array, decorators: [{
                type: Inject,
                args: [ResourceHolder]
            }] }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EnergyTranslateModule, { imports: function () { return [CommonModule, ɵngcc4.TranslateModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EnergyTranslateModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useFactory: HttpLoaderFactory,
                            deps: [HttpClient, TranslationResourceInjectable]
                        }
                    })
                ],
                declarations: [],
                exports: []
            }]
    }], null, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EnergyTranslatePipeMock, [{
        type: Pipe,
        args: [{
                name: 'translate'
            }]
    }], function () { return []; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EnergyTranslateServiceStub, [{
        type: Injectable
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(EnergyTranslateTestingModule, { declarations: [EnergyTranslatePipeMock], exports: [EnergyTranslatePipeMock] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EnergyTranslateTestingModule, [{
        type: NgModule,
        args: [{
                declarations: [EnergyTranslatePipeMock],
                exports: [EnergyTranslatePipeMock]
            }]
    }], null, null); })();

/*
 * Public API Surface of energy-frame-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ApplicationDesc, ApplicationService, AuthInfo, AuthService, CalendarLocale, DateTimeFormat, EnergyFrameModule, EnergyTranslateModule, EnergyTranslatePipeMock, EnergyTranslateServiceStub, EnergyTranslateTestingModule, HeaderComponent, HelpService, HttpLoaderFactory, KiDatePipe, KiNumberPipe, Language, LanguageProperties, LanguageService, LicenseService, LicenseViewerComponent, LocaleService, ParameterService, SideMenuItemStatus, SidemenuComponent, SidemenuItemComponent, SidemenuService, TenantComponent, TenantService, Theme, ThemeService, VersionsService, WindowRef, getLocalStorage, localeIdFactory, EnergyFrameLibRoutingModule as ɵa, ContentComponent as ɵb, LanguageSelectionComponent as ɵc, AuthInterceptorService as ɵd, EnergyTranslateHttpLoader as ɵe, ResourceHolder as ɵf, TranslationResourceInjectable as ɵg };

//# sourceMappingURL=energy-frame-lib.js.map